export default {

  "More": "Plus",

  "Change Vehicle": "Modifier le véhicule",

  "Assigned Truck": "Camion assigné",

  "VIN": "NIV",

  "Year": "Année",

  "Manufacturer": "Fabricant",

  "Model": "Modèle",

  "Accept": "Accepter",

  "Please provide Cycle Details": "Veuillez fournir les détails du cycle.",

  "Vehicle Type": "Type de véhicule",

  "Property": "Propriété",

  "Passenger": "passager",

  "Cycle Rule": "Règle du cycle",

  "USA 70 Hour / 8 day": "États-Unis 70 heures / 8 jours",

  "USA 60 Hour / 7 day": "États-Unis 60 heures / 7 jours",

  "Local Radius": "Rayon local",

  "Exceptions": "Exceptions",

  "30 Minute Break Exception": "Exception de pause de 30 minutes",

  "24 hour cycle": "Cycle de 24 heures",

  "Fuel Tracker": "Suivi du carburant",

  "Fuel Amount (enter amount in gallons)": "Quantité de carburant (entrer la quantité en gallons)",

  "Odometer": "Compteur kilométrique",

  "Total Cost": "Coût total",

  "Receipt": "Reçu",

  "View Policies": "consulter les politiques",

  "Please Read and Sign Policies and Procedures": "Veuillez lire et signer les politiques et procédures",

  "Driving Training": "Formation à la conduite",

  "Accident Investigation": "enquête sur un accident",

  "Inspection": "Inspection",

  "Driver Selection MVR": "Sélection du conducteur MVR",

  "Distraction Free Driving": "Conduite sans distraction",

  "PSP Usage": "Utilisation du PSP",

  "Loss Control Manual": "Manuel de contrôle des pertes",

  "Email used to send Missing Information": "E-mail utilisé pour envoyer les informations manquantes",

  "Edit Signature": "modifier la signature",

  "Clear Signature": "Effacer la signature",

  "Company Info": "Informations sur l'entreprise",

  "Name": "Nom",

  "ID": "ID",

  "Contact Person": "personne à contacter",

  "Address": "Adresse",

  "Phone": "Téléphone",

  "Website": "site web",

  "Contact Person 2": "PERSONNE À CONTACTER 2",

  "Phone 2": "TÉLÉPHONE 2",

  "Address 2": "ADRESSE 2",

  "Rate the App": "Évaluez l'application",

  "Share the App": "Partager l'application",

  "Settings": "Paramètres",

  "Time Zone": "Fuseau horaire",

  "Enter Unit ID or VIN number": "Entrez l'identifiant de l'unité ou le numéro d'identification du véhicule (VIN)",

  "You do not have a vehicle assigned": "Vous n'avez pas de véhicule attribué.",

  "Back": "Retour",

  "Enter Location": "Entrer le lieu",

  "Your Location": "Votre emplacement",

  "Remarks": "Remarques",

  "Time Left": "Temps restant",

  "Break": "Frein",

  "Time Remaining until Break": "Temps restant avant la pause",

  "Cycle": "Cycle",

  "Cycle Time Remaining": "Temps restant avant la fin du cycle",

  "On Duty": "En service",

  "ON_DUTY": "EN SERVICE",

  "Off Duty": "Hors service",

  "OFF_DUTY": "HORS SERVICE",

  "On Duty Time Remaining": "Temps de service restant",

  "HOS (Hours of Service)": "HOS (heures de service)",

  "Miles": "Miles",

  "Hours": "heures",

  "Hours worked today": "Heures travaillées aujourd'hui",

  "Hours Available Today": "Heures disponibles aujourd'hui",

  "Hours Available Tomorrow": "Heures disponibles demain",

  "Expand": "Développer",

  "Dashboard": "Tableau de bord",

  "Sleeping": "Veille",

  "Edit": "Modifier",

  "Sign": "Signe",

  "Driver": "Conducteur",

  "Carrier": "Transporteur",

  "Vehicles": "Véhicules",

  "Trailers": "Remorques",

  "From": "De",

  "To": "Vers",

  "Main": "Principal",

  "Home": "Accueil",

  "Ship Docs": "Documents d'expédition",

  "Notes": "Remarques",

  "Tap to Edit Log": "Appuyez pour modifier le journal",

  "Begin New Inspection": "Commencer une nouvelle inspection",

  "DVIR": "DVIR",

  "DOT": "DOT",

  "Front": "Avant",

  "Headlights": "Phares",

  "Flashers": "Clignotants",

  "Fog Lights": "Phares antibrouillard",

  "Marker Lights": "Feux de position",

  "Engine Compartment": "Compartiment moteur",

  "Fluids": "Fluides",

  "Belts": "Courroies",

  "Hoses": "tuyaux",

  "Compressor": "compresseur",

  "Brakes": "Freins",

  "Steering": "Direction",

  "Suspension": "suspension",

  "Proceed to Curbside Front Axle": "Passez à l'essieu avant côté trottoir",

  "Defect": "Défaut",

  "Enter Defect Description": "Entrer la description du défaut",

  "Enter Odometer Reading": "Entrez le kilométrage",

  "Mirrors": "Miroirs",

  "Tires": "Pneus",

  "Wheels": "Roues",

  "Curbside Rear Axle": "Essieu arrière côté trottoir",

  "Proceed to Rear": "Passez à l'arrière",

  "Driver Rear Axle": "Essieu arrière du conducteur",

  "Driver Front Axle": "Essieu avant du conducteur",

  "Cab": "Cab",

  "Horn": "Klaxon",

  "Fire Extinguisher": "Extincteur",

  "Wipers/Washers": "Essuie-glaces/lave-glaces",

  "Triangles": "Triangles",

  "Haz Mat Book": "Registre des matières dangereuses",

  "DOT Paperwork": "Documents administratifs DOT",

  "Brakes Bleed Down Test": "Test de purge des freins",

  "Test Parking Brakes": "Test des freins de stationnement",

  "Brakes Test Stop 1st Rotation of Wheels": "Test des freins Arrêt 1ère rotation des roues",

  "Assess Vehicle Conditions": "Évaluer l'état du véhicule",

  "Unsatisfactory": "Insatisfaisant",

  "Satisfactory": "Satisfaisant",

  "Sign and Save Report": "Signer et enregistrer le rapport",

  "Send All": "Tout envoyer",

  "Record Violations": "Enregistrer les infractions",

  "Inspect Logs/DVIRS": "Inspecter les registres/DVIRS",

  "Email Logs and DVIR": "Journaux électroniques et DVIR",

  "Create Inspection Report": "Créer un rapport d'inspection",

  "Record": "Enregistrer",

  "Take Photo": "Prendre une photo",

  "Finish Inspection": "Terminer l'inspection",

  "Inspect Documents": "Inspecter les documents",

  "Pull Over to Safe Location": "Do not admit fault. Check for injuries",

  "Do not Admit Fault": "Ne pas admettre la faute",

  "Check for Injuries": "Vérifier les blessures",

  "Please Confirm that you have been involved in an accident or press cancel to return to the dashboard": "Veuillez confirmer que vous avez été impliqué dans un accident ou appuyez sur Annuler pour revenir au tableau de bord",

  "Injuries-Call 911": "Blessures - Appeler le 911",

  "Step 1/5": "Étape 1/5",

  "Take photos of all 4 corners of each vehicle and 2 photos of the accident scene": "Prenez des photos des quatre coins de chaque véhicule et deux photos du lieu de l'accident 4 2",

  "broadview 2": "broadview 2",

  "driver front": "conducteur avant",

  "passenger front": "passager avant",

  "driver rear": "conducteur arrière",

  "passenger rear": "passager arrière",

  "other vehicle and property damage": "autres dommages matériels et aux véhicules",

  "Example: Guard rail, signs, light pole, etc. add # of photos needed": "Exemple : glissière de sécurité, panneaux de signalisation, lampadaire, etc. Ajouter le nombre de photos nécessaires",

  "Important: Get statements from all witnesses": "Important : obtenir les déclarations de tous les témoins",

  "add party involved": "ajouter une partie impliquée",

  "Add Witness": "Ajouter un témoin",

  "other driver": "autre conducteur",

  "passenger of other vehicle": "passager de l'autre véhicule",

  "full name": "Nom complet",

  "driver license number": "numéro du permis de conduire",

  "insurance information": "informations d'assurance",

  "audio statement": "déclaration audio",

  "describe the following": "décrire ce qui suit",

  "Vehicles involved, what happened, speed limit, time of day, weather, road conditions": "Véhicules impliqués, ce qui s'est passé, limite de vitesse, heure de la journée, conditions météorologiques, conditions routières",

  "Driver Statement": "Déclaration du conducteur",

  "Police Report": "Rapport de police",

  "Report Number": "Numéro de rapport",

  "Officer Name": "Nom de l'agent",

  "Badge Number": "Numéro de matricule",

  "Police Report Photo": "Photo du rapport de police",

  "Finish": "Terminer",

  "You did not complete your pre-trip DVIR before you started driving": "Vous n'avez pas rempli votre DVIR avant de commencer à conduire.",

  "view inspection report": "voir le rapport d'inspection",

  "view photos": "voir les photos",

  "scheduled start date": "date de début prévue",

  "scheduled due date": "date d'échéance prévue",

  "search vehicles": "Rechercher des véhicules",

  "History": "Historique",

  "change signature": "changer de signature",

  "please provide your signature": "veuillez apposer votre signature",

  "edit signature": "modifier la signature",

  "Loss control manual": "Manuel de contrôle des pertes",

  "accident investigation": "enquête sur un accident",

  "contact person": "personne à contacter",

  "Other address": "Autre adresse",

  "Other phone": "Autre numéro de téléphone",

  "Other contact person": "Autre personne à contacter",

  "Vehicle search": "Recherche de véhicule",

  "Fog lights": "Phares antibrouillard",

  "Engine compartment": "Compartiment moteur",

  "suspension": "suspension",

  "my vehicles": "mes véhicules",

  "Leave comments": "Laisser des commentaires",

  "change driver": "changer de pilote",

  "Exit": "Sortie",

  "New Work Orders": "Nouveaux bons de travail",

  "service type": "type de service",

  "view policies": "consulter les politiques",

  "Company info": "Informations sur l'entreprise",

  "Send Feedback": "Envoyer les commentaires",

  "Share the app": "Partager l'application",

  "Not Started": "Non démarré",

  "In Progress": "En cours",

  "Awaiting Parts": "Pièces en attente",

  "Repair": "Réparation",

  "Safety Repair": "Réparation de sécurité",

  "Switch to Driver": "Commutateur vers le pilote",

  "Dashboard Page": "Page du tableau de bord",

  "Company Summary": "Résumé de l'entreprise",

  "Total Drivers": "Nombre total de conducteurs",

  "Driving": "Conduite",

  "DRIVING": "Conduite",

  "Total Trucks": "Nombre total de camions",

  "In Shop": "En atelier",

  "Out of Service": "Hors service",

  "Logs-": "Journaux",

  "Users": "Utilisateurs",

  "Accidents": "Accidents",

  "Repair and Maintenance": "Réparation et entretien",

  "Inspections": "Inspections",

  "Reports": "Rapports",

  "Manage Logs": "Gérer les journaux",

  "Date From": "Date de début",

  "View": "Afficher",

  "Clear": "Effacer",

  "Hours Worked": "Heures travaillées",

  "Distance": "Distance",

  "Tools": "Outils",

  "Telephone": "Téléphone",

  "Online": "En ligne",

  "Manage Users": "Gérer les utilisateurs",

  "Search User": "Rechercher un utilisateur",

  "Add New User": "Ajouter un nouvel utilisateur",

  "Import User": "Importer les utilisateurs",

  "Full Name": "Nom complet",

  "Role": "Rôle",

  "Hire Date": "DATE DE LOCATION",

  "Assigned Vehicles": "Véhicules assignés",

  "Documents": "Documents",

  "Joined": "Joined",

  "Last Drug Test": "Dernier test de dépistage de drogues",

  "Last Login": "Dernière connexion",

  "Quick Filters": "Filtres rapides",

  "Mechanics": "Mécaniciens",

  "Fleet Managers": "Gestionnaires de flotte",

  "Admins": "Administrateurs",

  "All": "Tout",

  "Search Vehicle": "Recherche par véhicule",

  "Add new vehicle": "Ajouter un nouveau véhicule",

  "Add New Trailer": "Ajouter une nouvelle remorque",

  "List of Vehicles": "Liste des véhicules",

  "Drivers": "conducteurs",

  "Accidents-": "Accidents-",

  "Manage Accidents": "Gestion des accidents",

  "Photos": "Photos",

  "Witness Statement": "Déclaration du témoin",

  "Accident Report": "Rapport d'accident",

  "Date and Time": "Date et heure",

  "Repair and Maintenance-": "Réparation et entretien -",

  "Manage Work Orders": "Gérer les bons de travail",

  "Search Work Order": "Recherche d'ordre de travail",

  "Repair Cost": "Coût de la réparation",

  "Service Type": "type de service",

  "View Report": "Afficher le rapport",

  "Driver’s Vehicle Inspection Report-": "Rapport d'inspection du véhicule du conducteur -",

  "Location": "Emplacement",

  "No defects Found": "Aucun défaut trouvé",

  "Defects have been corrected": "Les défauts ont été corrigés",

  "Repairs not needed for safe operation of the vehicle": "Réparations non nécessaires pour le fonctionnement sécuritaire du véhicule",

  "User Main Informacion": "Informations principales sur l'utilisateur",

  "First name": "PRÉNOM",

  "Last name": "NOM",

  "Cell Phone": "TÉLÉPHONE",

  "Reset Password": "Réinitialisation du mot de passe",

  "Password": "Mot de passe",

  "Confirm Password": "Confirmer le mot de passe",

  "Safety Fleet Management-": "Gestion de la flotte de sécurité -",

  "Alerts": "alertes",

  "Date": "Date",

  "Drivers On Duty": "Chauffeurs en service",

  "View More": "En savoir plus",

  "Daily Logs": "Journaux quotidiens",

  "Hours Driving": "Heures de conduite",

  "Potential Violations": "Violations potentielles",

  "Violation Type": "Type de violation",

  "Recent Accidents": "Accidents récents",

  "Full name": "Nom complet",

  "Please fill in atleast one assigned driver and its corresponding annotation": "Veuillez indiquer au moins un conducteur désigné et l'annotation correspondante",

  "Company Data": "Données sur l'entreprise",

  "Company": "Entreprise",

  "Dot #": "Point n°",

  "Maintenance Period(months)": "Période d'entretien (mois)",

  "Maintenance Mileage": "Kilométrage d'entretien",

  "Contract Expiration Date": "Date d'expiration du contrat",

  "Current Subscription Cost": "Coût actuel de l'abonnement",

  "Number of Trucks": "Nombre de camions",

  "Home Time Zone": "Fuseau horaire",

  "Main Information": "Informations principales",

  "Company Logo": "Logo de l'entreprise",

  "Select Policies": "Sélectionnez les politiques",

  "Driver Training": "Formation du conducteur",

  "Training Days": "Jours de formation",

  "Hours of Training to be completed annually": "Heures de formation à effectuer chaque année",

  "Full name of Safety Manager": "Nom complet du responsable de la sécurité",

  "Driver Selection And MVR": "Sélection du conducteur et MVR",

  "Maximum number of accidents": "Nombre maximal d'accidents",

  "Maximum allowable number of citations": "Nombre maximal autorisé de contraventions",

  "Minimum years on similar equipment": "Nombre minimum d'années d'expérience sur un équipement similaire",

  "Driver Selection and MVR": "Sélection du conducteur et MVR",

  "FRONT": "Avant",

  "CURBSIDE REAR AXLE": "Essieu arrière côté trottoir",

  "DRIVER REAR AXLE": "Essieu arrière du conducteur",

  "DRIVER FRONT AXLE": "Essieu avant du conducteur",

  "Hours of Training to be Completed Annually": "Heures de formation à effectuer chaque année",

  "Full Name of Safety Manager": "Nom complet du responsable de la sécurité",

  "Safety repair": "Réparation de sécurité",

  "Cost": "coût",

  "Server Error": "Erreur serveur",

  "OK": "OK",

  "Info": "Info",

  "Success": "Succes",

  "Confirm logout": "Confirmer la déconnexion",

  "Are you sure you want to log out of this application?": "Êtes-vous sûr de vouloir vous déconnecter de cette application ?",

  "Confirm": "Confirmer",

  "Add": "ajouter",

  "Error": "Erreur",

  "Input Error": "Erreur de saisie",

  "Please enable location": "Veuillez activer la localisation",

  "Please enable all permission": "Veuillez activer toutes les autorisations",

  "Retry": "Réessayer",

  "Feedback": "Retroaction",

  "Logs": "Journaux",

  "New": "Nouveau",

  "Scheduled": "PRÉVU",

  "DVIR Listing": "Liste DVIR",

  "Sleeper": "COUCHAGE",

  "SLEEPER_BERTH": "COUCHETTE",

  "OIL_FIELD_WAITING": "ATTENTE_CHAMP_PÉTROLIER",

  "DRIVE": "DRIVE",

  "Time Remaining": "Temps restant",

  "Roadside Inspection": "Inspection routière",

  "HOS": "HOS",

  "Start Break": "Début de la pause",

  "Complete": "Terminé",

  "MINUTES": "Minutes",

  "hrs left": "heures restantes",

  "ELD Connected": "ELD connecté",

  "ELD Disconnected": "ELD déconnecté",

  "Pending Approval": "En attente d'approbation",

  "Login to your account": "Connectez-vous à votre compte",

  "Forgot Your Password?": "Mot de passe oublié ?",

  "Log In": "Connexion",

  "Email/Employee ID": "E-mail/Identifiant employé",

  "USERNAME": "NOM D'UTILISATEUR",

  "Please enter valid username": "Veuillez saisir un nom d'utilisateur valide",

  "Please enter valid password": "Veuillez saisir un mot de passe valide",

  "Login Fail": "Échec de connexion",

  "Wrong username or password.": "Nom d'utilisateur ou mot de passe incorrect.",

  "Your login is already in use": "Votre identifiant est déjà utilisé",

  "Log me in": "Me connecter",

  "The company is suspended, please contact your fleet manager.": "La société est suspendue, veuillez contacter votre gestionnaire de flotte.",

  "Please enter email address to reset your password": "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe",

  "Submit": "Soumettre",

  "Please enter a valid email address": "Veuillez saisir une adresse e-mail valide",

  "Check your inbox for the link to reset your password.": "Consultez votre boîte de réception pour obtenir le lien permettant de réinitialiser votre mot de passe.",

  "Reset Success": "Réinitialisation réussie",

  "Reset Password Failed": "Échec de la réinitialisation du mot de passe",

  "Wrong email": "Adresse e-mail incorrecte",

  "You are required to use ELD": "Vous êtes tenu d'utiliser un ELD.",

  "You are exempt from using ELD": "Vous êtes exempté de l'utilisation de l'ELD",

  "Please provide your cycle details": "Veuillez fournir les détails de votre cycle",

  "Select": "Sélectionner",

  "Personal Conveyance": "Transport personnel",

  "Yard Moves": "Mouvements de la cour",

  "Non-DOT": "Non DOT",

  "Distance In": "Distance parcourue",

  "Hardware": "Matériel",

  "Device Name": "Nom du dispositif",

  "Scan": "Analyser",

  "Select device": "Sélectionner un appareil",

  "Please read the following information carefully": "Veuillez lire attentivement les informations suivantes",

  "Send agreement by email": "Envoyer l'accord par e-mail",

  "Disagree": "En désaccord",

  "Agree": "D'accord",

  "No supported app found": "Aucune application prise en charge trouvée",

  "Terms and Conditions": "Conditions générales",

  "You are logged in from another device": "Vous êtes connecté depuis un autre appareil",

  "EXIT TO LOGIN": "SORTIE POUR CONNEXION",

  "Signature saved": "Signature enregistrée",

  "Add your Signature": "Ajouter votre signature",

  "Vehicle": "Véhicule",

  "Decline": "Déclin",

  "Continue without a vehicle": "Continuer sans véhicule",

  "View Trailer": "Voir la bande-annonce",

  "You are working in Non-Vehicle mode\\nUse SEARCH to find a vehicle or contact your fleet manager": "Vous travaillez en mode Non-Véhicule\\nUtilisez la fonction RECHERCHER pour trouver un véhicule ou contactez votre gestionnaire de flotte",

  "Use SEARCH to find a vehicle or contact your fleet manager": "Utilisez la fonction RECHERCHER pour trouver un véhicule ou contactez votre gestionnaire de flotte",

  "Sorry no vehicle found": "Désolé, aucun véhicule trouvé",

  "Change Trailer": "Modifier la remorque",

  "UNIT": "UNIT",

  "Log Details": "Détails du journal",

  "Unidentified Driver Logs": "Journaux de conduite non identifiés",

  "ELD Info": "Informations sur l'ELD",

  "Share": "Partager",

  "Manual": "Manuel",

  "Daily Documents": "Documents quotiediens",

  "Switch to Mechanic": "Commutateur vers le mécanicien",

  "TIME ZONE OFFSET FROM UTC": "DÉCALAGE DU FUSEAU HORAIRE PAR RAPPORT À L'UTC",

  "CHART": "CARTE",

  "I hereby certify that my data entries and my record of duty status for the 24-hour period are true and correct": "Je certifie par la présente que les données que j'ai saisies et mon registre de service pour la période de 24 heures sont véridiques et exacts.",

  "Not Ready": "Non prêt",

  "Remarks should be at least 4 characters": "Les remarques doivent comporter au moins 4 caractères.",

  "Edit Log Info": "Modifier les informations du journal",

  "Save Edits": "Enregistrer les modifications",

  "Add Trailers": "Ajouter des remorques",

  "Please separate Trailer Names with a comma": "Veuillez séparer les noms des remorques par une virgule.",

  "Log Successfully updated": "Journal mis à jour avec succès",

  "Notes must have 4-60 characters": "Les notes doivent comporter entre 4 et 60 caractères",

  "Edit Event": "Modifier l'événement",

  "Select Status": "Sélectionner le statut",

  "OFF": "HORS",

  "ON": "EN",

  "SB": "SB",

  "DR": "DR",

  "OW": "OW",

  "START": "DÉBUT",

  "END": "FIN",

  "DURATION": "DURÉE",

  "PERSONAL USE": "Usage personnel",

  "OILFIELD EXEMPTION": "EXEMPTION POUR LES CHAMPS PÉTROLIERS",

  "AG EXEMPTION": "EXEMPTION AG",

  "Non-DOT Trip": "Déplacement non DOT",

  "Location must have minimum 5 characters and maximum 60 characters": "L'emplacement doit comporter au minimum 5 caractères et au maximum 60 caractères",

  "Note must have minimum 4 character and maximum 60 characters": "La note doit comporter au minimum 4 caractères et au maximum 60 caractères",

  "Send": "Envoyer",

  "Enter annotation": "Entrer une annotation",

  "Add New Event": "Ajouter un nouvel événement",

  "Re-assign": "Réattribuer",

  "Warning": "Avertissement",

  "DOT Inspection Guide": "Guide d'inspection DOT",

  "Send Logs to DOT": "Envoyer les journaux au DOT",

  "View Log History": "Consulter l'historique des journaux",

  "View Manual": "Consulter le manuel",

  "Log History": "Historique du journal",

  "SPEED (mph)": "VITESSE (mph)",

  "ODOMETER (Miles)": "ODOMÈTRE (miles)",

  "ODOMETER (Kilometer)": "ODOMÈTRE (kilomètres)",

  "ENGINE HOURS": "HEURES MOTEUR",

  "Report Issue": "Signaler un problème",

  "Update Firmware": "Mise à jour du micrologiciel",

  "Connected": "Connecté",

  "Disconnected": "Déconnecté",

  "Please connect to the ELD for updating the odometer": "Veuillez vous connecter à l'ELD pour mettre à jour le compteur kilométrique",

  "Update": "Mise à jour",

  "Please connect to the ELD for updating the Firmware": "Veuillez vous connecter à l'ELD pour mettre à jour le micrologiciel",

  "NOTATION": "NOTATION",

  "Please enter a notation": "Veuillez saisir une annotation",

  "Send Logs": "Envoyer les journaux",

  "Logs successfully sent": "Journaux envoyés avec succès",

  "Oil Field Waiting": "Champ petrolifere-en attente",

  "Agricultural Exemption": "Exemption agricole",

  "Adverse Condition": "Conditions défavorables",

  "Your Location (5-60 chars)": "Votre emplacement (5 à 60 caractères)",

  "Remarks (Max 60 chars)": "Remarques (60 caractères maximum)",

  "Unable to logout while Driving. Please change your status to On Duty or Off Duty or Sleeper.": "Impossible de se déconnecter pendant la conduite. Veuillez modifier votre statut en « En service », « Hors service » ou « En pause ».",

  "Unable to change vehicle while Driving or in Sleeper. Please change your status to On Duty or Off Duty.": "Impossible de changer de véhicule pendant la conduite ou en mode sommeil. Veuillez changer votre statut en « En service » ou « Hors service ».",

  "This application is running background.": "Cette application s'exécute en arrière-plan.",

  "You are working in Non-Vehicle mode": "Vous travaillez en mode « Non-véhicule ».",

  "Connection lost to device": "Connexion perdue avec l'appareil",

  "Please check connection to ELD device and double check whether Bluetooth connection is working.": "Veuillez vérifier la connexion à l'appareil ELD et vérifier que la connexion Bluetooth fonctionne.",

  "Ignore": "Ignorer",

  "Connect to new Device": "Se connecter à un nouvel appareil",

  "Enter current odometer value in miles": "Entrez la valeur actuelle du compteur kilométrique en miles",

  "Enter odometer value here": "Entrez la valeur du compteur kilométrique ici",

  "Please enter a valid odometer value": "Veuillez saisir une valeur kilométrique valide",

  "Started processing unidentified logs": "Début du traitement des journaux non identifiés",

  "Unidentified logs processing has been completed": "Le traitement des journaux non identifiés est terminé",

  "You will have to switch status to Off Duty or On Duty to begin the rest break. Are you sure you want to begin rest break?": "Vous devrez passer au statut « Hors service » ou « En service » pour commencer la pause. Êtes-vous sûr de vouloir commencer la pause ?",

  "Go On Duty": "Mise en service",

  "Go Off Duty": "Mise hors service",

  "Vehicle In Motion": "Véhicule en mouvement",

  "Functionality is limited while the vehicle is in motion": "La fonctionnalité est limitée lorsque le véhicule est en mouvement",

  "Are you sure you want to continue in Personal Conveyance?": "Êtes-vous sûr de vouloir continuer dans le transport personnel ?",

  "Stay in PC": "Rester en PC",

  "Delay before auto switch to ON DUTY": "Délai avant le passage automatique en mode ON DUTY",

  "STAY DRIVING": "CONTINUER À CONDUITE",

  "Driver Profile": "Profil du conducteur",

  "Mechanic Profile": "Profil du mécanicien",

  "Mechanic Name": "Nom du mécanicien",

  "Change": "Modifier",

  "No Trailers": "Aucune remorque",

  "No Vehicle": "Aucun véhicule",

  "Please enter your password before returning to the Driver Dashboard": "Veuillez saisir votre mot de passe avant de revenir au tableau de bord du conducteur",

  "Alert": "Alerte",

  "No unidentified logs available": "Aucun journal non identifié disponible",

  "You are on the latest firmware version": "Vous disposez de la dernière version du micrologiciel",

  "Update available": "Mise à jour disponible",

  "A new version of firmware is available. If you proceed to update, please don\\'t leave this page or quit the application until the update completes.": "Une nouvelle version du micrologiciel est disponible. Si vous procédez à la mise à jour, veuillez ne pas quitter cette page ni fermer l'application avant la fin de la mise à jour.",

  "Firmware Update": "Mise à jour du micrologiciel",

  "Update in progress": "Mise à jour en cours",

  "Error while updating firmware": "Erreur lors de la mise à jour du micrologiciel",

  "The ELD will reboot, so please try connecting to the ELD again.": "L'ELD va redémarrer, veuillez donc essayer de vous reconnecter à l'ELD.",

  "Phone number": "Numéro de téléphone",

  "Other phone number": "Autre numéro de téléphone",

  "Website link": "Lien vers le site web",

  "copied!": "copié !",

  "New Version Available": "Nouvelle version disponible",

  "An update is available on Play Store. Please update to new version to continue using the application": "Une mise à jour est disponible sur le Play Store. Veuillez mettre à jour vers la nouvelle version pour continuer à utiliser l'application",

  "Manage Co-Drivers": "Gérer les copilotes",

  "Remove": "Supprimer",

  "Reject": "Rejeter",

  "Co-Driver Remove Confirmation": "Confirmation de suppression du copilote",

  "Are you sure you want to remove Tony as your co-driver?": "Êtes-vous sûr de vouloir supprimer Tony comme copilote ?",

  "Tony is requesting you to be his co-driver for Unit 1.": "Tony vous demande d'être son copilote pour l'unité 1.",

  "Tony is requesting to remove you as his co-driver for Unit 1 Please confirm.": "Tony demande à vous retirer de la liste de ses copilotes pour l'unité 1. Veuillez confirmer.",

  "Add Co-Drivers": "Ajouter des copilotes",

  "Please search and add Co-Drivers by clicking on the search bar.": "Veuillez rechercher et ajouter des copilotes en cliquant sur la barre de recherche.",

  "Enter Co-Driver Name": "Entrer le nom du copilote",

  "Co-driver request has been sent": "La demande de copilote a été envoyée",

  "Co-Driver Request Error": "Erreur de demande de copilote",

  "Request failed": "Demande échouée",

  "Co-Driver Request": "Demande de copilote",

  "Today": "Aujourd'hui",

  "TOTAL": "Total",

  "Kilometers": "Kilomètres",

  "Annotation should be at least 4 characters": "L'annotation doit comporter au moins 4 caractères",

  "Approve Log": "APPROUVER LE JOURNAL",

  "Reject Log": "JOURNAL DES REFUS",

  "Select Co-Driver": "Sélectionner copilote",

  "Successfully assigned to co-driver": "Attribution réussie au copilote",

  "No Inspections": "Aucune inspection",

  "Driver Inspection": "Inspection du conducteur",

  "Sign and Sync All DVIRs": "Signer et synchroniser tous les DVIR",

  "Sync All DVIRs": "Synchroniser tous les DVIR",

  "Synced": "Synchronisé",

  "Signed": "Signé",

  "You are being placed into On Duty Not Driving status": "Vous êtes placé en statut « En service, ne conduisant pas ».",

  "ODOMETER IN MILES": "ODOMÈTRE EN MILES",

  "ODOMETER IN KILOMETERS": "ODOMÈTRE EN KILOMÈTRES",

  "Pre-Trip": "Pré-déplacement",

  "Post-Trip": "Post-déclenchement",

  "Edit Defect description": "Modifier la description du défaut",

  "Add remarks": "Ajouter des remarques",

  "Odometer value is mandatory": "La valeur du compteur kilométrique est obligatoire",

  "Please enter value for \\\"ODOMETER\\\" field": "Veuillez saisir une valeur dans le champ « ODOMETER » (Compteur kilométrique).",

  "Done editing inspection?": "Vous avez terminé l'inspection ?",

  "Dismiss inspection": "Rejeter l'inspection",

  "Proceed to": "Passez à",

  "This feature is not subscribed. Please contact your fleet manager for more details.": "Cette fonctionnalité n'est pas activée. Veuillez contacter votre gestionnaire de flotte pour plus d'informations.",

  "Upgrade Required": "Mise à niveau requise",

  "Please upgrade to use this feature": "Veuillez effectuer la mise à niveau pour utiliser cette fonctionnalité",

  "Upgrade": "Mise à niveau",

  "Other": "Autre",

  "REMOVE DOCUMENT": "SUPPRIMER LE DOCUMENT",

  "Delivery Receipts": "Reçus de livraison",

  "Dispatch Records": "Envoyer les dossiers",

  "Bills of Lading": "Connaissements",

  "Receipts": "Reçus",

  "Weight Tickets": "Tickets de poids",

  "Communication Records": "Enregistrements des communications",

  "Other Documents": "Autres documents",

  "Daily Eld Other": "Quotidien Eld Autre",

  "View Document": "Afficher le document",

  "Create Document": "Créer un document",

  "CUSTOMER NAME": "Nom du client",

  "JOB NAME": "Nom du poste",

  "BILL OF LADING NUMBER": "NUMÉRO DU CONNAISSEMENT",

  "Upload New Document": "Telecharger nouveau document",

  "Successfully Deleted Document": "Document supprimé avec succès",

  "Incorrect or corrupted request": "Demande incorrecte ou corrompue",

  "Your profile was saved": "Votre profil a été enregistré",

  "Enter job name": "Entrer le nom du poste",

  "Enter customer name": "Entrer le nom du client",

  "Enter bill of lading number": "Entrer le numéro du connaissement",

  "You may not manually change status to driving, since you have a co-driver assigned": "Vous ne pouvez pas modifier manuellement le statut en mode conduite, car vous avez un copilote assigné.",

  "You may not manually change status to driving without connecting to ELD": "Vous ne pouvez pas modifier manuellement le statut en conduite sans vous connecter à l'ELD",

  "Currently on": "Actuellement activé",

  "Turn Off": "Désactiver",

  "Update Shipping \\ Document Number": "Mettre à jour le numéro du document d'expédition",

  "Enter shipping doc number": "Entrer le numéro du document d'expédition",

  "Shipping doc number": "NUMÉRO DE DOCUMENT D'EXPÉDITION",

  "Please enter valid shipping doc number": "Veuillez saisir un numéro de document d'expédition valide",

  "Please accept or reject the pending log for the day before accepting the UD event": "Veuillez accepter ou refuser le journal en attente pour la journée avant d'accepter l'événement UD",

  "Please assign or reject UD logs present before logging out": "Veuillez attribuer ou rejeter les journaux UD présents avant de vous déconnecter",

  "Trailer Type": "Type de remorque",

  "Make": "Marque",

  "Plate Number": "Numéro de plaque",

  "Assigned Vehicle": "Véhicule assigné",

  "Next Maintenance Date": "PROCHAINE DATE DE MAINTENANCE",

  "Device SN": "Numéro de série de l'appareil",

  "Select a trailer type": "Sélectionner un type de remorque",

  "Enter a unit ID": "Entrez un identifiant d'unité",

  "Enter VIN": "Entrez le numéro d'identification du véhicule",

  "Enter year": "Entrer l'année",

  "Enter make": "Entrer la marque",

  "Enter model": "Entrer le modèle",

  "Sign and Save the Report": "Signer et enregistrer le rapport",

  "Accident": "Accident",

  "Please CONFIRM that you have been involved in an accident": "Veuillez CONFIRMER que vous avez été impliqué dans un accident",

  "Injuries - Call 911": "Blessures - Appelez le 911",

  "Alert to server will be skipped due to no internet connectivity": "L'alerte au serveur sera ignorée en raison d'une connexion Internet inexistante",

  "911 Alert to server will be skipped due to no internet connectivity": "L'alerte 911 au serveur sera ignorée en raison de l'absence de connexion Internet",

  "STEP 1/4 INJURIES": "ÉTAPE 1/4 BLESSURES",

  "STEP 2/4 PICTURES": "ÉTAPE 2/4 PHOTOS",

  "STEP 3/4 WITNESSES": "ÉTAPE 3/4 TÉMOINS",

  "STEP 4/4 POLICE REPORT": "ÉTAPE 4/4 RAPPORT DE POLICE",

  "Dismiss accident": "Ignorer l'accident",

  "It is important to identify parties involved and gather their information right away. If there are no witnesses check CONTINUE.\\n\\nIMPORTANT: Get all Witness Statements": "Il est important d'identifier les parties impliquées et de recueillir immédiatement leurs informations. S'il n'y a pas de témoins, cochez CONTINUER. IMPORTANT : Obtenir toutes les déclarations des témoins",

  "Enter witness details below:": "Entrez les coordonnées du témoin ci-dessous :",

  "DRIVER LICENSE NUMBER": "numéro du permis de conduire",

  "ZIP CODE": "Code postal",

  "tel:911": "tél. : 911",

  "Choose witness type": "Choisissez le type de témoin",

  "REPORT NO": "RAPPORT N",

  "BADGE NO": "NUMÉRO D'IMMATRICULATION",

  "IMPORTANT: Take photos of all 4 corners of each vehicle and 2 photos of the accident scene.": "IMPORTANT : prenez des photos des 4 coins de chaque véhicule et 2 photos du lieu de l'accident.",

  "Describe the types of vehicles in the accident, what you saw happen, what time of day is it, was it poor road conditions, who you think is at fault.": "Décrivez les types de véhicules impliqués dans l'accident, ce que vous avez vu se passer, l'heure à laquelle cela s'est produit, si les conditions routières étaient mauvaises, qui vous pensez être responsable.",

  "Done recording": "Enregistrement terminé",

  "Cancel recording": "Annuler l'enregistrement",

  "ACCIDENT SCENE": "LIEU DE L'ACCIDENT",

  "TRUCK": "Camion",

  "TRAILER": "Remorque",

  "Example: Guard rail, signs, light pole, etc. (add # of photos as needed)": "Exemple : glissière de sécurité, panneaux de signalisation, lampadaire, etc. (ajouter le nombre de photos nécessaires)",

  "PHOTO": "Photo",

  "Witness name is mandatory": "Le nom du témoin est obligatoire",

  "Please enter Full Name": "Veuillez saisir votre nom complet.",

  "LogBook is not required.\\nYou\\'re operating under Local Radius duty cycle.": "Le journal n'est pas obligatoire. Vous opérez selon le cycle de service Local Radius.",

  "Order Id": "Numéro de commande",

  "Some error occurred. You can only view downloaded work orders.": "Une erreur s'est produite. Vous ne pouvez consulter que les bons de travail téléchargés.",

  "ORDER #": "NUMÉRO DE COMMANDE",

  "CREATED BY": "CRÉÉ PAR",

  "DEFECTS LIST": "LISTE DES DÉFAUTS",

  "DUE DATE": "Date d'échéance",

  "CONCERN": "Problème",

  "Completed": "Terminé",

  "DEFECT DETAILS": "DÉTAILS DU DÉFAUT",

  "COMMENTS BY MECHANIC": "COMMENTAIRES DU MÉCANICIEN",

  "Unable to retrieve service request detail. Service request ID was114": "Impossible de récupérer les détails de la demande de service. L'ID de la demande de service était 114.",

  "New Service Request": "Nouvelle demande de service",

  "Scheduled SR": "SR PRÉVU",

  "Satisfactory DVIRs": "DVIR satisfaisants",

  "DVIRs with Defects": "DVIR avec défauts",

  "All DVIRs": "Tous les DVIR",

  "Some error occurred. You can only view downloaded inspections.": "Une erreur s'est produite. Vous ne pouvez consulter que les inspections téléchargées.",

  "No DVIRs": "Pas de DVIR",

  "Sorry no vehicle assigned": "Désolé, aucun véhicule n'est attribué",

  "Are you sure you want to remove the vehicle?": "Êtes-vous sûr de vouloir supprimer le véhicule ?",

  "Please enter all required information.": "Veuillez saisir toutes les informations requises.",

  "Clutch Connectivity Log": "Journal de connectivité de l'embrayage",

  "In order to continue using Clutch ELD on this device you need to re-login.": "Pour continuer à utiliser Clutch ELD sur cet appareil, vous devez vous reconnecter.",

  "The future of Fleet Management! We bring the power of technology to your fleet through the most advanced transportation software on the market today. \\n\\nVisit us at www.clutcheld.com": "L'avenir de la gestion de flotte ! Nous mettons la puissance de la technologie au service de votre flotte grâce au logiciel de transport le plus avancé actuellement disponible sur le marché. \\n\\nRendez-vous sur www.clutcheld.com",

  "Tap here to proceed to": "Appuyez ici pour continuer",

  "24 Hour Cycle Reset": "Réinitialisation du cycle de 24 heures",

  "Oil Field Exception": "Exception pour les champs pétrolifères",

  "NONE": "Aucun",

  "Heavy Duty": "Usage intensif",

  "Light Duty": "Service léger",

  "Log out": "Déconnexion",

  "Are you sure you want to logout of this application?": "Êtes-vous sûr de vouloir vous déconnecter de cette application ?",

  "Continue": "Continuer",

  "Sorry no trailer assigned to this vehicle": "Désolé, aucune remorque n'est attribuée à ce véhicule",

  "Are you sure you want to delete the trailer?": "Êtes-vous sûr de vouloir supprimer la remorque ?",

  "Maximum trailer assigned to this vehicle, please remove any trailer to add new trailer": "Remorque maximale attribuée à ce véhicule, veuillez retirer toute remorque pour en ajouter une nouvelle",

  "This trailer is already assigned to a vehicle. Do you want to continue?": "Cette remorque est déjà attribuée à un véhicule. Voulez-vous continuer ?",

  "APPROVE": "Approuver",

  "No notifications": "Aucune notification",

  "Prime8 ELD has identified a data diagnostic event. The Prime8 ELD Diagnostic Event is MRDD.": "Prime8 ELD a identifié un événement de diagnostic de données. L'événement de diagnostic Prime8 ELD est MRDD.",

  "Please complete your pre-trip DVIR before starting driving.": "Veuillez remplir votre DVIR avant le départ avant de commencer à conduire.",

  "Please complete your post-trip DVIR at the end of the day.": "Veuillez remplir votre DVIR post-trajet à la fin de la journée.",

  "you did not your DVIR pre-trip before you started driving": "vous n'avez pas effectué votre DVIR avant de prendre la route",

  "If you have completed your day, please complete your post-trip DVIR.": "Si vous avez terminé votre journée, veuillez remplir votre rapport DVIR post-trajet.",

  "Prime8 ELD has reported a malfunction. Contact your manager immediately. Please stop using the Prime8 ELD RODS and switch to paper logs until the ELD malfunction has been corrected.": "Prime8 ELD a signalé un dysfonctionnement. Contactez immédiatement votre responsable. Veuillez cesser d'utiliser les RODS Prime8 ELD et passer aux registres papier jusqu'à ce que le dysfonctionnement de l'ELD soit corrigé.",

  "The Prime8 ELD Malfunction that has occurred is PCM.": "Le dysfonctionnement Prime8 ELD qui s'est produit est PCM.",

  "You violated 11hr Driving Limit.": "Vous avez dépassé la limite de conduite de 11 heures.",

  "You violated 14hr Driving Window Rule.": "Vous avez enfreint la règle des 14 heures de conduite.",

  "You violated Rest Breaks Rule.": "Vous avez enfreint la règle relative aux pauses.",

  "Your duty cycle has expired. You may be in violation.": "Votre cycle de service est arrivé à expiration. Vous risquez d'être en infraction.",

  "You violated 16 Hour Elapsed Time Rule.": "Vous avez enfreint la règle des 16 heures écoulées.",

  "You violated off-duty limit for today.": "Vous avez dépassé la limite de temps de repos pour aujourd'hui.",

  "You violated off-duty limit for last shift day.": "Vous avez dépassé la limite de temps hors service pour le dernier jour de quart.",

  "You are operating outside of compliance. Please sign your logbook.": "Vous conduisez en infraction. Veuillez signer votre carnet de bord.",

  "Certification is required for drivers updated log. Go to Logs page for pending action. Annotation provided in info tab.": "La certification est requise pour le journal mis à jour des conducteurs. Accédez à la page Journaux pour les actions en attente. Annotation fournie dans l'onglet Info.",

  "Please pair your device with ELD.": "Veuillez coupler votre appareil avec l'ELD.",

  "You are not connected to ELD.": "Vous n'êtes pas connecté à ELD.",

  "Your 14hr Driving Window is approaching. Please stop driving in 5 min.": "Votre fenêtre de conduite de 14 heures approche. Veuillez cesser de conduire dans 5 minutes.",

  "Your 11hr Driving Limit is approaching. Please stop driving in 5 min.": "Votre limite de conduite de 11 heures approche. Veuillez cesser de conduire dans 5 minutes.",

  "Please take 30 minute break from Driving within 5 min.": "Veuillez prendre une pause de 30 minutes après 5 minutes de conduite.",

  "You are out of driving hours. Please stop driving.": "Vous avez dépassé votre temps de conduite. Veuillez cesser de conduire.",

  "Delay in receiving data from ELD.": "Délai dans la réception des données provenant de l'ELD.",

  "Your Drive Time Expires": "Votre temps de conduite expire",

  "Your Break Time Expires": "Votre temps de pause expire",

  "Flatbed": "Plateau",

  "Dry Van": "Camion sec",

  "Reefer": "Réfrigérateur",

  "Tanker": "Citerne",

  "DRIVERS OF": "CONDUCTEURS DE",

  "Dump": "Benne",

  "Vacuum": "Dépression",

  "Pneumatic": "Pneumatique",

  "Service Center": "Centre de service",

  "Search Service Center": "Recherche par centre de service",

  "Sorry no service center found": "Désolé, aucun centre de service n'a été trouvé",

  "Use SEARCH to find a service center or contact your fleet manager": "Utilisez la fonction RECHERCHER pour trouver un centre de service ou contactez votre gestionnaire de flotte",

  "You are offline. Please check your internet connection. You are only be able to change service center only when you are online.": "Vous êtes hors ligne. Veuillez vérifier votre connexion Internet. Vous ne pouvez changer de centre de service que lorsque vous êtes en ligne.",

  "Fuel Amount": "QUANTITÉ DE CARBURANT",

  "Enter amount of gallons": "Entrez le nombre de gallons",

  "Enter fuel cost in $": "Entrez le coût du carburant en dollars",

  "You need to enter all fields values and attach receipt.": "Vous devez remplir tous les champs et joindre le reçu.",

  "Upload completed succesfully": "Téléchargement terminé avec succès",

  "Changes saved temporarily. The submitted receipts will be synced once you are online.": "Modifications enregistrées temporairement. Les reçus soumis seront synchronisés dès que vous serez en ligne.",

  "Enter part name": "Entrez le nom de la pièce",

  "Parts Inventory": "Inventaire des pièces",

  "No parts added. Please search and add the part.": "Aucune pièce ajoutée. Veuillez rechercher et ajouter la pièce.",

  "No related parts found. Try searching for different keywords.": "Aucune pièce associée trouvée. Essayez de rechercher d'autres mots-clés.",

  "Price": "Prix",

  "Part Name": "Nom de la pièce",

  "Inventory Count:": "Nombre d'inventaire :",

  "Part Already Selected!": "Pièce déjà sélectionnée !",

  "This part is already present in the parts list": "Cette pièce est déjà présente dans la liste des pièces.",

  "Parts have been updated": "Les pièces ont été mises à jour",

  "Delete": "supprimer",

  "No Work Orders": "Aucun ordre de travail",

  "Unable to retrieve service request detail. Work order ID was 1100": "Impossible de récupérer les détails de la demande de service. L'ID de l'ordre de travail était 1100",

  "New WO": "Nouvelle commande",

  "Scheduled WO": "WO planifié",

  "WO History": "Historique WO",

  "WO #": "WO #",

  "Review WO": "Révision WO",

  "Canada 70 hour / 7 day South": "Canada 70 heures / 7 jours Sud",

  "Canada 120 hour / 14 day South": "Canada 120 heures / 14 jours Sud",

  "Canada 80 hour / 7 day North": "Canada 80 heures / 7 jours Nord",

  "Canada 120 hour / 14 day North": "Canada 120 heures / 14 jours Nord",

  "Vehicle Compliant With 396 Regulations?": "Véhicule conforme à la réglementation 396 ?",

  "NO": "Non",

  "YES": "Oui",

  "Dailylog": "Journal quotidien",

  "DRIVER\\'S DAILY LOG": "JOURNAL QUOTIDIEN DU CONDUCTEUR",

  "Please read and sign all your policies and procedures": "Veuillez lire et signer toutes vos politiques et procédures",

  "You have not signed policies and procedures": "Vous n'avez pas signé les politiques et procédures.",

  "There was an issue signing policy. Try again later.": "Un problème est survenu lors de la signature de la politique. Veuillez réessayer plus tard.",

  "Policy ID is invalid": "L'ID de la politique n'est pas valide",

  "Policies": "Politiques",

  "Mechanic feature is not subscribed. Please contact your fleet manager for more details.": "La fonctionnalité Mécanicien n'est pas souscrite. Veuillez contacter votre gestionnaire de flotte pour plus de détails.",

  "DEFECTS DETAILS": "DÉTAILS DES DÉFAUTS",

  "COMMENTS BY DRIVER": "COMMENTAIRES DU PILOTE",

  "VIEW PHOTOS": "voir les photos",

  "Missing parts check": "Vérification des pièces manquantes",

  "Please perform the check on all parts in the current section and mark as Ok/Defect": "Veuillez vérifier toutes les pièces de la section actuelle et les marquer comme OK/Défectueuses",

  "OUT OF SERVICE": "Hors service",

  "You are allowed only to switch to Adverse Driving Mode since you have a co-driver assigned. Do you need to enable ADC mode?": "Vous êtes uniquement autorisé à passer en mode de conduite défavorable, car vous avez un copilote assigné. Avez-vous besoin d'activer le mode ADC ?",

  "You are allowed only to switch to Adverse Driving Mode without connecting to ELD. Do you need to enable ADC mode?": "Vous êtes uniquement autorisé à passer en mode conduite défavorable sans vous connecter à l'ELD. Souhaitez-vous activer le mode ADC ?",

  "You cannot begin inspection in non-vehicle mode. Please choose a vehicle to continue": "Vous ne pouvez pas commencer l'inspection en mode non-véhicule. Veuillez choisir un véhicule pour continuer.",

  "Fuel Info": "Informations sur le carburant",

  "Manage Parts": "Gérer les pièces",

  "Are you sure you want to remove the part?": "Êtes-vous sûr de vouloir supprimer cette pièce ?",

  "You have service requests awaiting review. Go to service requests review page for pending action.": "Vous avez des demandes de service en attente de vérification. Accédez à la page de vérification des demandes de service pour effectuer les actions en attente.",

  "Accident data will be lost and nothing will be sent to server": "Les données relatives à l'accident seront perdues et rien ne sera envoyé au serveur",

  "Are you sure you want to remove the receipt?": "Êtes-vous sûr de vouloir supprimer le reçu ?",

  "No Service Request": "Aucune demande de service",

  "Please contact the sales team to continue using the app": "Veuillez contacter l'équipe commerciale pour continuer à utiliser l'application.",

  "Assess vehicle conditions:": "Évaluer l'état du véhicule :",

  "Assess trailer conditions:": "Évaluer l'état de la remorque :",

  "UNSATISFACTORY": "Insatisfaisant",

  "SATISFACTORY": "Satisfaisant",

  "VEHICLE NAME": "Nom du véhicule",

  "REPORTED": "Signalé",

  "SCHEDULE": "PROGRAMMATION",

  "TOTAL COST": "Coût total",

  "LABOUR COST": "COÛT DE MAIN-D'ŒUVRE",

  "PARTS COST": "COÛT DES PIÈCES",

  "PART": "Pièce",

  "VIEW REPORT": "Afficher le rapport",

  "CORRECTION": "Correction",

  "CAUSE": "Cause",

  "Completed WO": "Travaux terminés",

  "NEW SR": "Nouveau SR",

  "COMPLETED SR": "TERMINÉ SR",

  "SR #": "SR #",

  "ODOMETER": "Compteur kilométrique",

  "RECEIPT": "Reçu",

  "Enter amount in gallons": "Entrez la quantité en gallons",

  "Enter odometer reading": "Entrez le kilométrage",

  "Enter total fuel cost in $": "Entrez le coût total du carburant en $",

  "Your fuel info have empty fields or no receipt": "Vos informations sur le carburant comportent des champs vides ou aucun reçu.",

  "Location cannot be empty": "Le champ « Emplacement » ne peut pas être vide",

  "The Pdf link is not available please contact the admin": "Le lien PDF n'est pas disponible, veuillez contacter l'administrateur",

  "Reported defect does not have any images attached": "Le défaut signalé n'est accompagné d'aucune image",

  "Please approve/reject all the defect items": "Veuillez approuver/refuser tous les éléments défectueux.",

  "Please fix all the defect items before completing the work order": "Veuillez corriger tous les éléments défectueux avant de terminer l'ordre de travail",

  "There are no images attached for this work order": "Aucune image n'est jointe à cet ordre de travail.",

  "No parts found": "Aucune pièce trouvée",

  "Sorry you have already selected this part": "Désolé, vous avez déjà sélectionné cette pièce",

  "Already Added": "Déjà ajouté",

  "Please enter notes": "Veuillez saisir vos remarques",

  "You should enter start and due dates": "Vous devez saisir les dates de début et d'échéance.",

  "Start date must be earlier than due date": "La date de départ doit être antérieure à la date d'échéance",

  "Add service center": "Ajouter un centre de service",

  "Enter Service Center Name": "Entrer le nom du centre de service",

  "No Service Center found": "Aucun centre de service trouvé",

  "Please choose one the service center before submiting": "Veuillez choisir un centre de service avant de soumettre",

  "User was de-activated successfully": "Utilisateur a ete desactive avec succes",

  "User was activated successfully": "Utilisateur a ete active avec succes",

  "A verification email has been sent to your email. Please click on the link to enable email notifications": "Un e-mail de vérification a été envoyé à votre adresse e-mail. Veuillez cliquer sur le lien pour activer les notifications par e-mail",

  "You have disabled email notifications": "Vous avez desactive les notifications par email",

  "Successfully enabled the notification": "Active des notivications avec succes",

  "Invalid file!": "Fichier invalide!",

  "Default Fleet Manager cannot be deleted or de-activated": "Le gestionnaire de flotte par défaut ne peut pas être supprimé ou désactivé",

  "Invalid token": "Jeton invalide",

  "Token expired or invalid JWT token": "Jeton expire out jeton JWT invalide",

  "User's email can't be empty": "L'email de l'tuilisateur ne peut pas etre vide",

  "The e-mail is not registered": "L'email n'est pas inscrit",

  "You are not authorized to do this request": "Vous n'êtes pas autorisé à faire cette demande",

  "User was deleted successfully": "L'utilisateur a ete supprime avec success",

  "Failed to activate user": "Echec de l'activation de l'utilisateur",

  "User not found": "Utilisateur pas trouve",

  "Time zone not available": "Fuseau horaire indisponible",

  "Please enter no more than 50 characters": "Veuillez entrer 50 caracteres ou moins",

  "user has region already assigned to him": "L'utilisateur a deja un region attricue",

  "Subscription not available": "Abonnedment indisponible",

  "Please agree to the Terms Of Use": "Veuillez accepter les conditions d'utilisation",

  "Company with this email already exists": "Enterprise avec cette address existe deja",

  "Flex companies cannot have more than 3 vehicles": "Les enterprises flex ne peuvent pas avoir plus de 3 vehicules",

  "Invalid producer code": "Code producteur invalide",

  "Company with the given dot number already exists": "Enterprise avec numero dot donne exist deja",

  "Please enter a valid password": "Veuillez entrer un mot de passe valide",

  "Timezone not found. Please enter a valid timezone": "Fuseau horaire pas troube",

  "Invalid payment details": "Details de paiement invalides",

  "Invalid captcha": "CAPTCHA Invalide",

  "Card Cannot be Registered/Charged in BrainTree": "La carte ne peut pas être enregistrée/débitée dans BrainTree",

  "Flex registration is not enabled": "L'enregistrement flexible n'est pas activé",

  "Payment failed": "Paiement echoue",

  "BrainTree Exception occured during Payment": "Une exception BrainTree s'est produite pendant le paiement.",

  "Company not found": "Enterprise pas trouve",

  "Your feedback has been sent successfully": "Vos commentaires on ete envoyes avec succes",

  "There are active service requests existing for this vehicle": "Il exist de demandes de service actives pour ce vehicule",

  "Please delete users under this department\"": "Veuillez supprimer des utilisateurs de ce departement",

  "Please delete location under this department": "Veuillez supprimer emplacement de ce departement",

  "Department already exists": "Departement exist deja",

  "Cannot reset filter set by fleet manager": "Impossible de reinitialiser l'emplacement defini par le gestionnaire de flotte",

  "Location already exists": "Emplacement exist deja",

  "Cannot reset location set by fleet manager": "Impossible de reinitializer emplacement regle par gestionnaire de flotte",

  "Region already exists": "La region existe deja",

  "Please remove users under this region": "Veuillez supprimer les utilisateurs de cette region",

  "Please delete terminal under this region": "Veuillez supprimer terminal sous cette region",

  "Cannot reset region set by fleet manager": "Impossible de reinitialiser region regle par le gestionnaire de flotte",

  "Terminal already exists": "Terminal esiste deja",

  "Please remove users under this terminal": "Veuillez supprimer utilisateurs sous ce terminal",

  "Please delete departments under this terminal": "Veuillez supprimer les departement sous ce terminal",

  "Cannot reset terminal set by fleet manager": "Impossible de reinitialiser terminal regle par le gestionnaire de flotte",

  "Please delete users under this location": "Veuillez supprimer utilisateurs de cette location",

  "Cannot reset subdepartment set by fleet manager": "Impossible de reinitializer sou-departement regle par gestionnaire de flotte",

  "Account deactivated": "Compte desactive",

  "Invalid username/password": "Nom d'utilisateur/mot de passe invalide",

  "Some error occurred": "Une erreur s'est produite",

  "User userName not found": "Nom d'utilisateur introuvable",

  "permission denied": "Autorisation refusée",

  "The user doesn't exist": "L'utilisateur n'existe pas",

  "Password does not match": "Le mot de passe ne correspond pas",

  "Upgrade Subscription": "MISE À NIVEAU DE L'ABONNEMENT",

  "Rejected Successfully": "Rejete avec succes",

  "Accepted Successfully": "Accepte avec succes",

  "Developer Request Accepted": "Demand du developpeur accepte",

  "Exception occurred while exporting results": "Une exception s'est produite lors de l'exportation des résultats",

  "Invalid or corrupted token": "Jeton invalide ou corrompu",

  "Company does not exist": "L'enterprise n'existe pas",

  "Please add the neccessary details and update your credit card details.": "Veuillez ajouter les détails nécessaires et mettre à jour les détails de votre carte de crédit.",

  "You are not able to change Company Data information": "Vous ne pouvez pas modifier les informations sur les données de l'entreprise",

  "In Update card : General Exception Caught": "Dans la carte de mise à jour : Exception générale détectée",

  "Not allowed to access other company daily logs": "Pas autorisé à accéder aux journaux quotidiens d'autres entreprises",

  "Not allowed to access other drivers daily logs": "Pas autorise a acceder aux journaux quotidiens d'autres conducteurs",

  "New version of real time log is now available for the user.": "La nouvelle version du journal en temps réel est maintenant disponible pour l'utilisateur",

  "Update card details": "Mettre a jour les details de la carte",

  "Document with the same name was already uploaded for this user!": "Un document portant le même nom a déjà été téléchargé pour cet utilisateur !",

  "Invalid format!": "Format invalide!",

  "Deleted!": "Supprime!",

  "Please enter a Valid VIN conforming to the VIN standard": "Veuillez entrer un vin valide conforme à la norme VIN",

  "Duplicate VIN exist in truck details": "Un VIN en double existe dans les détails du camion",

  "No such User": "Aucune utilisateur",

  "No Vehicle Found": "Aucune vehicule trouve",

  "Vehicle with vin Vin1 already exists": "Le vehicule avec vin VIN1 existe deja.",

  "part1 (s) are not available in inventory": "Le(s) pièce(s)1 ne sont pas disponibles",

  "email already exists in the database": "L'email existe deja",

  "Company Registration Failed:": "L'enregistrement de l'enterprise a échoué",

  "Company with same dot number dotnumber1 already exists": "Une enterprise avec le meme numero de DOT dotnumber1 existe deja",

  "Please enter only numbers and maximum length as 9": "Veuillez entrer uniquement des chiffres.  Le longueur maximale est de 9",

  "Please enter minimum 4 characters": "Veuillez entrer au moins quatre caracteres",

  "Please enter only numbers": "Veuillez entrer uniquement des chiffres.  Le longueur maximale est de 9",

  "Please enter email address in valid format": "Veuillex entrer l'addresse email au format valide",

  "User with email email1 already exists": "Utilisateure avec email email1 existe deja",

  "Please use only numbers and - and. Length must be 12 digits": "Veuillez utiliser uniquement numers et-et.  Longueur doit etre 12 chiffres.",

  "Please enter value between 2 and 30 characters": "Veuillez entrer valeur entre 2 et 30 caracters",

  "Company not exist": "L'enterprise n'existe pas",

  "User not exist": "L'utilisateur n'existe pas",

  "Company Id not exist": "Le numero d'identite d'enterprise n'exste pas",

  "Credit card number should contain only numbers": "Le numero de carte de credit ne doit contenir que des chiffres",

  "Please enter valid credit card number": "Veuillez entrer numero de carte de credit valide",

  "Please enter valid cvv": "Veuillez entre CVV valide",

  "Please enter expiry date in valid format [MM/YY]": "Veuillez entrer la date d'expiration au format valide (mm/aa)",

  "Shipping option must be either Standard or Express": "L'option d'expedition doit etre STANDARE ou EXPRESS",

  "Subscription plan must be either Monthly or Yearly": "L'opetion d'abonnement doit etre MENSUELLE ou ANNUEL",

  "Permission Denied : Report not enabled for user": "Autorisation refusee.  Rapport non active pour l'utilisateur.",

  "Date format not correct": "Format de date pas correct",

  "Exception occurred while exporting dailyHosViolationReport": "Une exception s'est produite lors de l'exportation du rapport quotidien de violation Hos",

  "Exception occurred while exporting dailyUnsignedLogReport": "Une exception s'est produite lors de l'exportation du rapport quotidien de journal non signé",

  "Exception occurred while exporting dailyFailedInspectionReport": "Une exception s'est produite lors de l'exportation du rapport quotidien d'inspection échoué",

  "Exception occurred while exporting dailyUnidentifiedDrivingReport": "Une exception s'est produite lors de l'exportation du rapport quotidien de conduite non identifiée",

  "Some error occurred while cancelling the subscription. Please try after some time": "Une erreur s'est produit lors de l'annulation de l'abonnement.  Veuillez essayer apres un certain tems.",

  "Trucks number can't be less than count of active trucks": "Le nombre de camions ne peut pas etre inferieur au nombre de camions actifs.",

  "Card Exception occured. Please retry with another card or try again later": "Une exception de carte s'est produite.  Veuillez reessayer avec un autre carte ou reessayer plus tard",

  "name can not be empty": "Le nom ne peut pas etre vide",

  "type can not be null": "Le type ne peut pas etre nul",

  "year can not be null": "l'annee ne peut pas etre nul",

  "make can not be empty": "La marque ne peut pas etre vide",

  "model can not be empty": "Le modele ne peut pas etre vide",

  "nextMaintenance can not be empty": "La prochaine maintenance ne peut pas etre vide",

  "Partial content": "Contenu partiel",

  "USDOT Number already exists": "Numero de USDOT existe deja",

  "It's not possible to set the role \\\"Fleet Manager (Default)\\\" for inactive user": "Il n'est pas possible de definir le role de gestionnaire de flotte (par defaut)pour un utilisateur inactif.",

  "Manager (Default)": "Responsable (par défaut)",

  "License State is Mandatory for Drivers": "L'etat de la license est obligaroire pour les conducteures",

  "You can't modify Fleet Manager (Default) role to Fleet Manager, Driver or Admin or Mechanic roles": "Vous ne pouvez pas modifier le role de gestionnaire de flotte (defaut) en roles de gestionnaire de flotte, de conducteur ou d'administrateur ou de mecanician",

  "Please enter Value between 4 and 60 characters": "Vuellez entrer valeur entre 4 et 60 caracteres",

  "User with Employee ID user1 already exists": "Utlisateur avec l'ID user1 d'employe exist deja",

  "License Number license1 already exists": "Numero de licence license 1 existe deja",

  "Please enter Value between 1 and 20 characters": "Veuillez entrer Valeur entre 1 et 20 caracteres",

  "Please provide Hire Date in valid format(MM/DD/YYYY)": "Veuillez donner la date d'embauche dans un format valid (mm/jj/aaaa",

  "Please add some valid data": "Vueuillez ajouter des donnees valides",

  "Active": "Actif",

  "Inactive": "Inactif",

  "Only three trailers are allowed per Vehicle": "Suelement trois remorques sont autorisees par vehicule",

  "No Drivers Found for this vehicle": "Aucun conducteur trouve pour ce vehicule",

  "driver does not sign his logbook": "Conducteur ne signe pas son journal",

  "driver does not complete a DVIR": "Conducteur ne termine pas un DVIR",

  "Driver is driving a vehicle with a safety defect": "Le conducteur conduit un vehicule avec un defaut de securite",

  "Driver goes over his/her driving hours": "Conducteur depasse ses heures de conduite",

  "Driver goes over his/her duty hours": "Conducteur depasse ses heures de service",

  "Driver goes over his/her cycle hours": "Conducteur depasse ses heures de cycle",

  "Driver has not taken a break or break was too short": "Conducteur n'a pas fait de pause our la pause a ete trop courte.",

  "You should enter scheduled and due date.": "Vous devez entrer la date prevue et la date d'echeance.",

  "Scheduled date must be earlier than due date.": "La date prevue doint etre anterieure a la date d'echeance.",

  "Dates can't be before reported date.": "Les dates ne peuvent pas etre anterieures a la date indiquee",

  "Access Credentials -": "Acceder aux identifiants",

  "Registration Confirmation - GorillaSafety.com": "Confirmation d'inscription - GorillaSafety.com",

  "Hardware Ordered- GorillaSafety.com": "Matériel commandé - GorillaSafety.com",

  "Malfunction Occured -": "Dysfonctionnement s'est produit",

  "Password Reset -": "Reinitialisation du mot de passe",

  "User1 has not signed his logbook": "L'utilisateur1 n'a pas signe son journal",

  "The DRIVING Window is expired for User1": "La fenetre de CONDUITE es expiree pour l'utilisateur1",

  "The DRIVING Window is about to expire for User1": "La fenetre de CONDUITE de utilisateur1 est sur le point d'expirer",

  "The ON_DUTY Window is expired for User2": "La fenetre de service est expiree pour l'utilisateur2",

  "The ON_DUTY Window is about to expire for User2": "La fenetre de service de l'utilisateur2 est sure le point d'expirer",

  "The Duty Cycle limit is expired for User3": "La limite du cycle de service a expire pour l'utilisateur3.",

  "The Duty Cycle limit is about to expire for User3": "La limite du cycle de service pour l'utilisateur3 est sur le point d'expirer.",

  "User1 has been involved in an accident at Texas": "L'utilisateur1 a ete implique dans un accident au Texas",

  "User1 has been involved in an accident at Texas and called 911 indicating injuries are present": "L'utilisateur1 a ete implique dans un accident au Texas et telephone 911 indiquant que des blessures sont presentes",

  "User1 has not completed DVIR before driving": "L'utilisateur1 n'a pas termine le DVIR avant de conduire.",

  "User1 has not completed DVIR for yesterday after driving": "L'utilisateur 1 n'a pas rempli le DVIR pour hier après avoir conduit",

  "User1 has not completed DVIR after driving": "L'utilisateur1 n'a pas termine le DVIR apres avoir conduit",

  "User2 drives wrong vehicle": "L'utilisateur2 conduit le mauvais vehicule",

  "Eld not paired": "ELD non couple",

  "Eld not connected": "ELD pas connecte",

  "Positioning compliance malfunction occurred": "Un dysfonctionnement de la conformite du positionnement s'est produit",

  "Data recording compliance malfunction occurred": "Un dysfonctionnement de la conformite de l'enregistrement des donnees s'est produit",

  "Power compliance malfunction occured": "Un dysfonctionnement de la conformite de la puissance s'est produit",

  "Engine synchronization compliance malfunction occurred": "Un dysfonctionnement de la conformite de la synchronisation du moteur s'est produit",

  "Data transfer compliance malfunction occurred": "Un dysfonctionnement de la conformite du tranfert de donnees s'est produit s'est produit",

  "DVIR DEFECT": "DEFAULT DVIR",

  "Unit No.Unit1 has been repaired": "L'unite numero 1 a ete reparee",

  "DVIR NOT SIGNED": "DVIR NON SIGNE",

  "User3 MVR will expire in 30 days": "MVR de l'utilisateur3 expirera dans 30 jours",

  "User4 MVR will expire in 14 days": "MVR de l'utilisateur4 expirera dans 14 jours",

  "User5 MVR will expire in 5 days": "MVR de l'utilisateur5 expirera dans 5 jours",

  "User6 MVR expired": "MVR de l'utilisateur6 a expire",

  "User7 Medical Card will expire in 45 days": "La carte medical de l'utilisateur7 expirera dans 45 jours",

  "User1 Medical Card will expire in 30 days": "La carte medical de l'utilisateur1 expirera dans 30 jours",

  "User1 Medical Card will expire in 15 days": "La carte medical de l'utilisateur1 expirera dans 15 jours",

  "User1 Medical Card expired": "La carte medical de utilisateur1 a expire",

  "User1 License will expire in 60 days": "La licence de l'utilisateur1 expirera dans 60 jours",

  "User1 License will expire in 30 days": "La licence de l'utilisateur1 expirera dans 45 jours",

  "User1 License will expire in 15 days": "La licence de l'utilisateur1 expirera dans 15 jours",

  "User1 License will expire in 7 days": "La licence de l'utilisateur1 expirera dans 7 jours",

  "User1 License expired": "Lacence de l'utilisateur1 a expire",

  "REPAIR OVERDUE": "REPARATION EN RETARD",

  "User1 has declined a vehicle": "L'utilisateur1 a refuse un vehicule",

  "User1 is driving Unit No.Unit1 with a safety Defect": "L'utilisateur1 conduit l'unite numero un (Unit 1) avec un defaut de securite",

  "User1 has never logged in": "L'utilisateur1 ne s'est jamais connecte",

  "Vehicle1 is missing driver/mechanic": "le vehicule1 manque de conducteur/mecanicien",

  "Safety defect repair overdue for Unit No.Unit1": "Reparation du defaut de securite en retard pour l'unite numero 1 (unit 1)",

  "User1 has Pending daily log for May 1": "L'utilisateur a un journal quotidien en attente pour le 1er mai.",

  "User1 has requested to access fleets": "L'utilisateur1 a demande l'acces aux flottes",

  "User1 exceeds the available time to drive": "L'utilisateur1 depasse le temps disponible pour conduire",

  "VIN of the vehicle does not match with the VIN pulled from the VNA for Vehicle1": "Le VIN du vehicule ne correspond pas au VIN extreit du VNA pour le vehicule1",

  "User1 has accumulated unidentified driving time on Vehicle1": "L'utilisateur1 a accumule du temps de conduite non identifie sur le vehicul1",

  "Please enter value between 4 and 120 character length": "Veuilllez entrer valeur entre 4 et 120 longueur de caracteres",

  "Please enter valid dotNumber of length between 1 and 9": "Veuillez saisir un numéro valide compris entre 1 et 9",

  "Company name cannot be empty": "Nom d'enterprise ne peut pas etre vide",

  "Dot Number cannot be empty": "Numero de DOT ne peut pas etre vide",

  "Minimum contract length should be 1 year": "La duree minimale  du contrat doit etre d'un an",

  "Maximum contract length should be 3 years": "La duree maximale du contrat doit etre 3 ans.",

  "Address cannot be empty": "L'adress ne doit pas etre vide",

  "State cannot be empty": "Etat ne peut pas etre vide",

  "Please enter a valid 2 letter state abbreviation": "Veuillez entrer abreviation d'etat valide a deux lettres",

  "City cannot be empty": "Ville ne peut pas etre vide",

  "Zipcode be empty": "Code postal ne peut pas etre vide",

  "Phone number cannot be empty": "Numero de telephone ne peut pas etre vide",

  "Owner First Name cannot be empty": "Prenom du proprietaire ne peut pas etre vide",

  "Owner Last Name cannot be empty": "Nom de famille du proprietaire ne peut pas etre vide",

  "Owner Phone number cannot be empty": "Numero de telephone du proprietaire ne peut pas etre vide",

  "Owner Email cannot be empty": "L'email du proprietaire ne peut pas etre vide",

  "Password cannot be empty": "Mot de passe ne peut pas etre vide",

  "Phone can not be empty": "Telephone ne peut pas etre vide",

  "Fleet": "Flotte",

  "Service_Center": "Centre de service",

  "Logbook": "Journal",

  "The value must be greater than 0": "Le valeur doit etre plus que zero",

  "Base service - $40/month per unit. (Web Portal Accident App and Inspection App)": "Service de base-40$par mois par unite \"Application d'accident de portal web et application d'inspection.",

  "Logbook App - $10/month per unit. (Additional)": "Application de journal-10$ par mois en plus",

  "USA 60h/7 days": "EU 60/7 jours",

  "USA 70h/8 days": "EU 70h/8 jours",

  "Texas 70h/7 day": "Texas 70h/7 jours",

  "Canada 70h/7 day South": "Canada 70h/7 jours Sud",

  "Canada 80h/7 day North": "Canada 80h/7 jours Nord",

  "Canada 120h/14 day South": "Canada 120h/14 jours Sud",

  "Canada 120h/14 day North": "Canada 12h/14 jours Nord",

  "Mexico": "Mexique",

  "Log time not available": "Heure du journal non disponible",

  "IDLE": "INACTIF",

  "0 MPH": "0 MPH",

  "Total Active Drivers": "Nombre total de conducteurs actifs",

  "Available Trucks": "Camions disponible",

  "UD Logs": "Journaux de UD",

  "Employment Application": "Demand d'emploi",

  "Medical Card": "Carte medical",

  "Driver License": "Licence de conduire",

  "MVR": "MVR",

  "Company Logotype": "Logo de l'entreprise",

  "MCS 150": "MCS 150",

  "Controlled Substance Documents": "Socuments sur les substances controlees",

  "Overweight Permits": "Permis de surcharge ponderale",

  "Safety Manual": "Manuel de Securite",

  "Corporate Documents": "Documents d'entreprise",

  "Driver Payroll Records": "Fiches de paie des conducteurs",

  "Equipment list": "Liste d'equipement",

  "Driver Trip Reports & Expense Records": "Rapports de trajet du conducteur et notes de frais",

  "MCS 90": "MCS 90",

  "Loss Runs": "Voyages sans profit",

  "Company Contract": "Contrat d'entreprise",

  "DOT Inspection Image": "DOT image d'inspection",

  "DOT Inspection Sound": "DOT bruit d'imspection",

  "DVIR Inspection Image": "DVIR Image d'inspection",

  "DVIR Inspection Sound": "DVIR Bruit d'inspection",

  "ADHOC Inspection Image": "ADHOC image d'inspection",

  "ADHOC Inspection Sound": "ADHOC bruit d'inspection",

  "Work Order Image": "Image de demande de service",

  "Parts Invoice": "Facture de piece",

  "Daily Log": "Journal",

  "ADHOC": "ADHOC",

  "Incomplete Daily Log": "Journal incomplete",

  "Malfunction Report": "RAPPORT DE DYSFONCTIONNEMENT",

  "User Signature": "Signature d'utilisateur",

  "Cab Card": "Carte de cabine",

  "Insurance Card": "Carte d'assurance",

  "Repair Receipts": "Recus de reparation",

  "Vehicle Registration": "Immatriculation du vehicule",

  "Permits": "Permis de surcharge ponderale",

  "Trailer Registration": "Immatriculation du remorque",

  "Individual Policy Template (DOCX)": "Modele de politique individuelle (DOCX)",

  "Individual Policy Template (PDF)": "Modele de politique individuelle (PDF)",

  "Individual Policy": "Modele de politique individuelle",

  "Import users": "Importer les utilisateurs",

  "Import vehicles": "Importer des véhicules",

  "Import trailers": "Remorques d'importation",

  "Status history": "Historiques des statuts",

  "Truck GPS history": "Historique GPS du camion",

  "ELD Data File": "Fichier de donnees ELD",

  "Fuel Receipt": "Recu de carburant",

  "Delivery Receipt": "Demande de livraison",

  "Dispatch Record": "Enregistrement d'envoi",

  "Bill of Lading": "Connaissement",

  "Weigh Ticket": "Billet de pesee",

  "Communication record": "Enregistrement des communications",

  "Other Document": "Autre document",

  "Payment Receipt": "Recu de paiement",

  "Driver Report": "Rapport du conducteur",

  "Violation Report": "RAPPORT DE VIOLATION",

  "Odometer Jump Report": "Rappor de saut d'odometre",

  "Mobile Debug Log": "Journal de debogage mobile",

  "Driving Event Report": "Rapport d'evenement de conduite",

  "ELD Disconnection Report": "Rapport de deconnexion ELD",

  "HOS Violations Detail Report": "Rapport detaille des violations HOS",

  "Unassigned Driver Report": "Rapport de conducteur non attribue",

  "Monthly Vehicle Maintenance Report": "Rapport d'entretien mensuel du vehicule",

  "DVIR Report": "Rapport DVIR",

  "keystore doesn't exists:": "Magasin de cles n'exist pas",

  "CURBSIDE FRONT AXLE": "Essieu avant côté trottoir",

  "REAR": "Arrière",

  "Front Headlights": "Phares avant",

  "Front Flashers": "Clingnotants avant",

  "Front Fog Lights": "Phares antibruillard avant",

  "Front Marker Lights": "Feux de position avant",

  "Front Engine Compartment": "Eclairage du compartiment moteur avant",

  "Front Fluids": "Fluides avant",

  "Front Belts": "Centures avant",

  "Front Hoses": "Durites avant",

  "Front Compressor": "Compresseur avant",

  "Front Brakes": "Freins avant",

  "Front Steering": "Direction avant",
  "Front Suspension": "Suspension avant",
  "vehicleOrFMsearch": "Utilisez RECHERCHE pour trouver un véhicule ou contactez votre gestionnaire de flotte.",
  "hours": "heures",
  "broadview": "Vue large",
  "identifyAllParties": "Il est important d’identifier toutes les parties impliquées et de recueillir immédiatement leurs informations. S’il n’y a pas de témoins, cliquez sur continuer.",
  "passenger": "passager",
  "witness": "témoin",
  "address": "adresse",
  "city": "ville",
  "state": "état",
  "signLogbook": "Vous êtes hors conformité. Veuillez signer votre journal de bord.",
  "maintance": "maintenance",
  "type": "type",
  "reported": "signalé",
  "status": "statut",
  "hoses": "durites",
  "compressor": "compresseur",
  "brakes": "freins",
  "steering": "direction",
  "settings": "paramètres",
  "logout": "se déconnecter",
  "done": "terminé",
  "cost": "coût",
  "receipt": "reçu",
  "choosePngJpg": "Veuillez choisir un format .png ou .jpg",
  "invalidCharacters": "Caractères non valides détectés et supprimés",
  "checkInternet": "Vous êtes hors ligne, veuillez vérifier votre connexion Internet",
  "breakEndsIn": "Votre pause se termine dans :",
  "movedToOffDutyStatus": "Vous serez passé au statut HORS SERVICE pour commencer la pause. Êtes-vous sûr de vouloir commencer la pause ?",
  "pendingReq": "Vous avez une demande en attente, souhaitez-vous la voir ?",
  "cycleSwitchNotPosiible": "Le changement de cycle n’est pas possible sans 24 heures hors service",
  "provideSign": "Fournir une signature avant d’enregistrer",
  "locationValidation": "L’emplacement doit contenir au moins 5 caractères et ne doit pas contenir de symboles spéciaux",
  "includeTrailerNames": "Incluez « , » entre les noms des remorques. Inclure uniquement les noms des remorques",
  "savedTemporarily": "Modifications enregistrées temporairement. Elles seront synchronisées une fois en ligne.",
  "vehicleMust": "Un véhicule doit être sélectionné pour atteler la remorque",
  "vehicleBeforeDrivingStatus": "Veuillez sélectionner un véhicule avant de passer au statut conduite",
  "vehicleBeforeSleeperStatus": "Veuillez sélectionner un véhicule avant de passer au statut couchette",
  "adjustEdit": "Vous ne pouvez pas modifier le temps de conduite capturé par l’ELD. Veuillez ajuster votre modification en conséquence",
  "logoutTrackingWillStop": "Vous allez vous déconnecter. Tout le suivi s’arrêtera",
  "viewLastDownloadDailyLogs": "Vous êtes hors ligne. Vous pouvez uniquement consulter les derniers journaux quotidiens téléchargés",
  "unidentifiedDriverLogsProcessed": "Les journaux des conducteurs non identifiés sont en cours de traitement. Veuillez réessayer plus tard",
  "addCoDriver": "Aucun copilote ajouté. Veuillez rechercher et ajouter un copilote en cliquant sur le bouton Ajouter",
  "incompleteInspection": "Vous ne pouvez pas continuer l’édition car l’inspection est incomplète et sera supprimée",
  "Pull over to safe location; Do not admit fault. Check for injuries": "Arrêtez-vous dans un endroit sûr ; n’admettez pas de faute. Vérifiez s’il y a des blessés",
  "accidentDataWillBeLost": "Les données de l’accident seront perdues et rien ne sera envoyé au serveur",
  "ScheduledDateBeforeReportedDate": "La date planifiée ne peut pas être antérieure à la date signalée",
  "DueDateGreaterthanScheduledOrReportedDate": "La date d’échéance ne peut pas être supérieure à la date planifiée ou signalée",
  "UnidentifiedDriverOnELD": "Un conducteur non identifié est présent sur l’ELD",
  "unexpectedErrorReq": "Une erreur inattendue s’est produite lors du traitement de la demande. Veuillez réessayer plus tard",
  "unexpectedError": "Une erreur inattendue s’est produite lors du traitement de l’inscription. Veuillez réessayer plus tard",
  "passwordValidation": "Le mot de passe doit contenir entre 6 et 15 caractères, incluant une majuscule, une minuscule, un chiffre et un symbole",
  "reprtBeingPrepared": "Votre rapport est en cours de préparation et sera envoyé à votre adresse e-mail",
  "linkToDownloadInspections": "Votre téléchargement est en cours de préparation. Vous recevrez un e-mail avec un lien pour télécharger les inspections",
  "subscriptionCancelled": "Votre abonnement a été annulé. Veuillez enregistrer à nouveau l’entreprise et essayer de vous connecter",
  "incorrectCredentials": "E-mail ou mot de passe incorrect. Veuillez réessayer avec des identifiants valides",
  "recoveryLink": "Le lien de récupération a été envoyé par e-mail",
  "VINnumberValidation": "Le numéro VIN doit contenir 17 caractères. Uniquement des lettres et des chiffres. I, O et Q ne sont pas autorisés",
  "valueBwtween1to10Length": "Veuillez entrer une valeur entre 1 et 10 caractères",
  "onlyNumbers": "Utilisez uniquement des chiffres et la longueur doit être de 12 chiffres",
  "lubrication": "lubrification",
  "Repaired": "réparé",
  "per DOT": "selon le DOT",
  "inspection": "inspection",
  "resetHelp": "aide à la réinitialisation",
  "note": "note",
  "TimeZone": "fuseau horaire",
  "LogBook": "journal de bord",
  "till": "jusqu’à",
  "failure": "défaillance",

  "Curbside Front Axle Mirrors": "Retroviseurs de l'essieu avant cote trottoir",

  "Curbside Front Axle Tires": "pneus d'essieu avant en bordure de trottoir",

  "Curbside Front Axle Wheels": "Roues d'essieu avant en bordure de trottoir",

  "Curbside Rear Axle Tires": "Pneus d'essieu arriere en bordure de trottoir",

  "Curbside Rear Axle Brakes": "Freins d'essieu arriere en bordure de trottoir",

  "Curbside Rear Axle Suspension": "Suspension dessieu arriere en bordure de trottoire",

  "Rear Exhaust": "Echappement arriere",

  "Rear Fifth Wheel": "Cinquieme roue arriere",

  "Rear Frame": "Cadre arriere",

  "Rear Lights": "Feux arriere",

  "Rear Flashers": "Clingnotants arriere",

  "Driver Rear Axle Tires": "Pneus de l'essieu arriere cote conducteur",

  "Driver Rear Axle Wheels": "Roues d'essieu arriere cote conducteur",

  "Driver Rear Axle Brakes": "Freins d'essieu arriere cote conducteur",

  "Driver Rear Axle Suspension": "Suspension d'essieu arriere cote conducteur",

  "Driver Front Axle Mirrors": "Retroviseurs de l'essieu avant cote conducteur",

  "Driver Front Axle Tires": "Pneus d'essieu avant cote conducteur",

  "Driver Front Axle Wheels": "Roues d'essieu avant cote conducteur",

  "Cab Horn": "Klaxon de cabine",

  "Cab Wipers/Washers": "Essuie-glaces/lave-glace de cabine",

  "Cab Fire Extinguish": "Extincteur de cabine",

  "Cab Triangles": "Triangle de cabine",

  "Cab Haz Mat Book": "Livre de matiere dangereuses de cabine",

  "Cab D.O.T. Paperwork": "Paperasserie DOT de cabine",

  "Cab Brakes Bleed Down Test": "Essai de purge des freins de la cabine",

  "Cab Brakes Low Air Warning Test": "Essai d'avertissement de manque d'air des freins de la cabine",

  "Cab Test Parking Brakes": "freins de stationnement d'essai de cabine",

  "Cab Brakes Test Stop 1st Rotation of Wheels": "Essai des freins de la cabine arret de la premiere rotation des roues",

  "Brake Connections": "raccords de freins",

  "Coupling Devices": "dispositifs d'attelage",

  "Coupling Pin": "Goupille d'attelage",

  "Doors": "Portes",

  "Hitch": "Attelage",

  "Landing Gear": "Train d'atterrissage",

  "Lights": "Lumieres",

  "Reflectors": "Reflecteurs",

  "Roof": "Toit",

  "Straps": "Bretelles",

  "Suspension System": "Systeme de suspension",

  "Tarpaulin": "Bache",

  "Wheels & Rims": "Roues ey jantes",

  "Fleet Manager Has Changed The Subscription Tier": "Le gestionnaire de flotte a change le niveau d'abonnement",

  "Fleet Manager Has Assigned A Log For You": "Le gestionnaire de flotte vous a attribue un journal",

  "User1 has sent you a co-driver request": "L'utilisateur1 vous a envoye une demande de copilote",

  "User1 has assigned you a dailyLog": "L'utilisateur 1 vous a attribué un journal quotidien",

  "User1 has completed the service request": "L'tilisateur1 a termine la demande de service",

  "Minimum driver age allowed": "Age minimum du conducteur autorise",

  "Allow Bluetooth Usage": "Autoriser l'utilisation du Bluetooth",

  "Company Name": "Nom d'etreprise",

  "Manager Name": "Nom de directeur",

  "Common": "Commun",

  "Email can not be empty": "Email ne peut pas etre vide",

  "Fleet Manager": "Gestionnaire de flotte",

  "Mechanic": "MÉCANICIEN",

  "Admin": "ADMIN",

  "Developer": "Developpeur",

  "Employee": "Employee",

  "Reseller": "Revendeur",

  "Reseller Employee": "Employee du revendeur",

  "Support": "Soutien",

  "Service Manager": "Gestionnaire de service",

  "View Only Fleet Manager": "Afficher uniquement le gestionnaire de flotte",

  "Last Name can not be empty": "Nom de famille ne peut pas etre vide",

  "First Name can not be empty": "Prenom ne peut pas etre vide",

  "Hire Date can not be empty": "La date d'embauche ne peut pas etre vide",

  "Phone Number can not be empty": "Numero de telephone ne peut pas etre vide",

  "Role cannot be empty": "Le role ne peut pas etre vide",

  "9 Pin": "9 Pin",

  "6 Pin": "6 Pin",

  "OBDII": "OBDII",

  "DUAL CAM": "Double cam",

  "Mack": "Mack",

  "Volvo": "Volvo",

  "Tractor Day Cab": "Cabine de jour pour camion",

  "Tractor Sleeper": "Cabine couchette",

  "Bobtail": "Bobtail",

  "Straight Truck": "Camion Porteur",

  "Box Truck": "Camion Fourgon",

  "Pickup": "Pick-Up",

  "Private Passenger": "Passager Prive",

  "Van": "Van",

  "Approved": "approuvé",

  "Closed": "Ferme",

  "Un Assigned": "Non attricue",

  "Maintenance": "Maintenance",

  "Repairs": "Reparations",

  "No details available": "Aucun detail disponible",

  "Successfully submitted to FMCSA": "Soumis avec succes a FMCSA",

  "Failed to send csv!": "Echec de l'envoi du CSV",

  "Failed to create daily log history csv": "Echec de la creation de l'historiquedu journal quotidien CSV",

  "No Logs available for the driver for the selected date range!": "Aucun journal disponible pour le conducteur pour la plage de dates selectionee",

  "No Logs available for the selected driver!": "Sucun journal disponible pour le conducteur selectione",

  "Failed to create daily log history csv!": "Echec de la creation de l'historiquedu journal quotidien CSV",

  "Unidentified Driver": "Conducteur non identifie",

  "Required dailyLog field 'comment' is empty": "Le champ « commentaire » obligatoire du journal quotidien est vide",

  "dailyLogEntries doesn't contain all readonly entries": "dailyLogEntries ne contient pas toutes les entrées en lecture seule",

  "File Format not allowed": "Format de fichier non autorise",

  "Log Added Successfully": "Journal ajoute avec succes",

  "Log Exists for the date selected": "Journal existe pour la date selectionnee",

  "Required dailyLog field 'note' is empty": "Le champ « note » obligatoire du journal quotidien est vide",

  "No valid entries to save": "Aucune entrée valide à enregistrer",

  "successfully updated": "Mis a jour avec succes",

  "User not found with name: User1": "Utilisateur introuvable avec le nom utilisateur1.",

  "Flex company cannot add more than 3 vehicles. This flex company already have 4 vehicle(s). This flex company already have 4 vehicle(s).": "Une entreprise Flex ne peut pas ajouter plus que 3 vehicules.  Cette entreprise Flex a deja 4",

  "Invalid vehicle type": "Type de vehicule invalide",

  "Invalid device type": "Type d'appareil invalide",

  "Please provide Unit ID": "Veuillez indiquer ID d'unite",

  "Please enter no more than 10 characters for Unit ID": "Veuillez ne pa entrer plus de 10 caracteres pour l'ID d'unite",

  "Please provide Make": "Merci de fournir la marque",

  "Please provide Model": "Veuillez de fournir le modele",

  "Please provide Next Maintenance Date": "Veuillez indiquer la date de la prochaine maintenance",

  "Driver with email email is being assigned to another vehicle in this file": "Conducteur avec email email est affecte a un autre vehicule dans ce fichier.",

  "User with email email does not exist,": "Utilisateur avec email email n'existe pas",

  "User with email email is not a driver,": "Utilisateur avec email email n'est pas conducteur",

  "Mechanic with email email does not exist,": "Mecanicien avec email email n'existe pas",

  "User with email email is not a mechanic,": "Utilisateur avec email email n'est pas mecanicien",

  "Trailer with vin Vin is being assigned to another vehicle in this file": "Remorque avec vin VIN est afecte a un autre vehicule dans ce fichier",

  "Trailer with vin Vin does not exist": "Remorque avec vin VIN n'exist pas",

  "No such region Region": "Aucune region Region de ce type",

  "No such terminal Terminal is available, since the region is invalid": "Aucun terminal Terminal de ce type n'est disponible car la region est invalide",

  "No such terminal Terminal for the region Region": "Aucun terminal Terminal  pour la region Region",

  "No such department Department is available, since the terminal is invalid": "Aucun departement Departement est disponible, car le terminal est invalide",

  "No such department Department for the terminal Terminal": "Aucun departement Departement pour le terminal Terminal",

  "No such location Location is available, since the department is invalid": "Aucun emplacement Emplacement de ce type n'est disponible car le departement est invalide",

  "No such location Location for the department Department": "Pas de emplacement Emplacement pour le departement Departement",

  "Please check the data is valid or header is correct": "Veuillez verifier que les donnees sont valides ou que l'entete est correct",

  "Invalid trailer type": "Type de remorque invalide",

  "Please enter Unit ID between 1 to 10 characters length": "Veuillez entrer ID de unite entre 1 et 10 caracteres de longueur",

  "Vehicle with VIN VIN does not exist in our system": "Vehicule avec vin VIN n'exist pas dans notre system",

  "First name should have at least 2 characters": "Prenom doit avoir au moins 2 caracteres",

  "Please provide First Name": "Veuillez fournir Prenom",

  "Please provide less than 30 characters for first name": "Veuillez fournir moins de 30 caracteres pour le prenom",

  "Please provide Last Name": "Veuillez fournir nom de famille",

  "Last name should have at least 2 characters": "Nom de famille doit avoir su moins 2 caracteres",

  "Please provide less than 30 characters for last name": "Veuillez fournir moins de 30 caracteres pour le nome de famille",

  "Please provide Phone": "Veuillez fournir telephone",

  "Please provide Email": "Veuillez fournir email",

  "Please provide Hire Date": "Veuillez fournir date d'embauche",

  "Role Role1 does not exist": "Role Role 1 est interdit",

  "Role1 role is not allowed": "Role Role 1 n'e",

  "Driver should have a licenseNumber": "Le conducteur doit avoir un numéro de permis",

  "Please enter no more than 20 characters for license number": "Veuillex entrer 20 caracteres maximum pour numero de licence",

  "Driver should have a State": "Conducteur doit avoir un Etat",

  "Driver should have Other, because the licenseState is Non-US": "Le conducteur doit avoir « Autre », car l'État du permis n'est pas américain",

  "This vehicle is already assigned to another Mechanic.": "Ce vehicule est deja attribue a un autre mecanicien",

  "Since the active vehicle count is less than the 75% of total vehicles, 75% of total vehicle count is taken": "Puisque le compte de vehicule est moins que 75% de total, 75% du nombre total est prise en compte",

  "Active vehicles taken": "Vehicules actifs pris",

  "Parts": "PIÈCES",

  "Tyre": "Pneu",

  "Mirror": "Miroir",

  "Safety Analytics Report By Vehicle For May 5 to May 8": "Rapport d'analyse de la securite par vehicule du 5 mai au 8 mai",

  "Confidential Information. Property of Gorilla Safety": "Informations confidentielles.  Propriete de GorillaSafety",

  "Page: 4": "Page 4",

  "Printed For: User1    Printed Date: 05/44/2021": "Imprime pour: Utilisateur1 Date 5/44/2021",

  "Total Cost ($) : 666": "Coute total ($)555",

  "Workorder Parts": "Pieces d'ordre de travail",

  "HOS Violations Detail": "DÉTAILS DES INFRACTIONS HOS",

  "HOS Violations Summary": "Resume d'infractions HOS",

  "Inspection Reports Detail": "Détail des rapports d'inspection",

  "PAYMENT INVOICE": "Facturer de paiement",

  "Payment Date": "Date de paiement",

  "Active trucks": "Camions Actifs",

  "Work order #": "Numero de demande de service",

  "Trailer :": "Remorque:",

  "Vehicle :": "Vehicule:",

  "Quantity": "Quantite:",

  "Cost ($)": "Coute ($)",

  "Event Start": "Debut d'evenement",

  "Event End": "Fin d'evenement",

  "Duration": "DURÉE",

  "Start Odo(mi)": "Debut ODO (mi)",

  "End Odo(mi)": "Fin Odo (mi)",

  "Distance(mi)": "Distance (mi)",

  "No Driving Events": "Aucun evenement de conduite",

  "Event Description": "Description de l'evenement",

  "Event Date/Time (in UTC)": "Dat/heure d'evenement (dans UTC)",

  "Actual Speed (mi)": "Vitesse reelle",

  "Vehicle : Vehicle1                                 Total Violations : 5": "Vehicule: Vehicule 1          Nombre total d'infractions:5",

  "Something went wrong while signing contract :": "Quelque chose s'est mal passe lors de la signature des contrats",

  "Confirmation of Order": "Confirmation de commande",

  "Thank you for signing up for the Tier1 service tier. The following is a breakdown of cost based on the service tier selected. Note that the cost is subject to change if upgraded to a higher service tier.": "Merci de vous etre inscrit au niveau de service Tier1.  Vous trouverez ci-dessous le detail des coutes en fonction du niveau de service selectionne.  Notez que le coute est susceptible de changer en cas de mise a niveau vers un niveau de service superieur.",

  "Total Cost Per Month($)": "Cout total par mois ($)",

  "Initial Truck Count": "Nombre initial de camions",

  "Cost Per Truck ($)": "Coût par camion ($)",

  "Contract Term:": "Terme du contrat",

  "Violations": "Infractions",

  "Driver Phone": "Telephone de conducteur",

  "Flag": "Drapeau",

  "Driver went over the permitted driving hours": "Conducteur a depasse les heures de conduite autorisees",

  "Driver went over the permitted cycle hours": "Conducteur a depasse les heures de cycle autorisees",

  "Driver did not sign the logbook": "Conducteur n'a pas signe le journal de bord",

  "Driver did not complete the DVIR": "Conducteur n'a pas termine le DVIR",

  "Driver has not taken a complete break": "Conducteur n'a pas fait de pause complet",

  "ELD Disconnects Detail": "ELD details de deconenecte",

  "Date Range   Nov 1 - Nov 3": "Plage de dates   Prenier Nov.- 3 Nov",

  "Disconnect Time": "Heure de deconnecte",

  "Disconnect Location": "Location de deconnecte",

  "Reconnect Time": "Heure de reconnexion",

  "Reconnect Location": "Location de reconnexion",

  "Disconnect Odometer (mi)": "Deconnecte odometre (mi)",

  "Reconnect Odometer (mi)": "Reconnextion odometre (mi)",

  "Distance (mi)": "Distance (mi)",

  "No ELD Disconnect": "Aucun ELD deconnecte",

  "Disconnect Timestamp": "Deconnecter l'horodatage",

  "Reconnect Timestamp": "Reconnecter l'horodatage",

  "No Odometer Jump Events": "Aun evenement de saut d'odometre",

  "No malfunction for the vehicle": "Aucun dysfonctionnement pour le vehicule",

  "Assigned To": "Assigne a",

  "No Unassigned Driver Logs": "Aucun journal de pilote non attribue",

  "No Inspection Reports": "Aucun rapport d'inspection",

  "Total Inspection Reports": "Total de rapports d'inspection",

  "Total Reports with Defects": "Total de rapports avec des defauts",

  "Trailer Defects": "Defauts de remorque",

  "Vehicle Defects": "Defauts de vehicule",

  "Time": "Heure",

  "Odometer (mi)": "Odometre (mi)",

  "\nFor the month of: Jan 2021": "Pour le mois de : janvier 2021",

  "This is a combination Service, Repair, Tire and Brake Condition Report. Report is to be completed and turned in within (5) days of the reporting month for the tractor to stay in operating status. FMCSR section 396.3 & 396.5 requires carriers to maintain a record of all maintenance performed with receipts on every tractor owned, leased, or rented.": "Il s'agit d'un rapport d'entrentien, de reparation, de pneu et d'etat des freins combine.  Le rappor doit etre rempli et remis, dan les 5 jours suivent le mois de delcaration pour que le camion reste en etat de fonctionnement.Les secions 396.3 et 395.5 du FMCSR exigent que les transporteurs teinnent un registre de tous les entretiens effectues avec des recus sur chaque tracteur posede ou loue.",

  "Owner/Driver:": "Proprietaire/conducteur",

  "Year:": "Annee:",

  "COMPLETION OF THIS FORM IS REQUIRED BY FEDERAL LAW": "REMPLIR CE FORMULAIRE EST REQUIS PAR LA LOI DFEDERALE",

  "REPAIRS:": "REPARATION:",

  "List all repairs, parts, or equipment installed for the month. If repairs are a result of a violation, please mark the “DOT inspection” column.": "Énumérez toutes les réparations, pièces ou équipements installés pour le mois. Si les réparations sont le résultat d'une violation, veuillez marquer le \"DOT",

  "Description of Repair": "Description de reparation",

  "New or Replacement Part": "Piece nouvelle ou de remplacement",

  "Repaired\nper DOT\ninspection": "Reparado por DOT inspeccion",

  "No commmon repair details found": "Aucun detail de reparation commun trouve",

  "LUBRICATION:": "LUBRIFICATION",

  "List all lube work (oil changes) on engine, transmission, differential, and 5 th wheel. Also list filter changes.": "Enumerez tous les travaix de lubrification (changement d'huile\" sure le moteur, las transmission, le differentiel et la sellette d'attelage.  Repertorier egalment les modifications de filtre.",

  "No lubrication repair details found": "Aucun detail de reparation de lubrification trouve",

  "Tires:": "Pneus",

  "List all flats repaired, tire changes, rotations, air pressure checks, tread checks, and new replacements.": "Enumerez toutes les crevaisons reparees, les changements de pneus, les rotations, les verifications de la band de roulement et les nouveaux remplacement",

  "No Tire repair details found": "Aucun detail de reparation de pneu trouve",

  "Brakes:": "Freins:",

  "List all repairs/maintenance to braking system (brake shoes, hub gaskets,brake lines, wheelseals, brake adjustments, or brake kits)": "Enumerez touts les reparations/maintenances du system de freinage (machoires de frein, joints de moyeu, conduites de frein, joints de roue, regalages de frein ou kids de frein",

  "No Brake repair details found": "Aucune alerte disponible",

  "History Of Driver": "Histoire du conducteur",

  "No Alerts Available": "Aucune alerte disponible",

  "No Driver Status History": "Aucun historique d'etat du conducteur",

  "Truck ID": "ID de camion",

  "Geocoded Location": "Emplacement geocode",

  "Updated Time": "Heure mise a jour",

  "MPH": "MPH",

  "Cycle Limit": "Limite de cycle",

  "14 Hour Shift Limit": "Limite de quart de tavail de 14 heures",

  "30 Minute Break Required": "Pause de 30 minutes obligatoire",

  "11 Hour Driving Limit": "Limite de conduite de 11 heures",

  "Drivers Audited": "Conducteurs audites",

  "HOS Violations": "Infractions de HOS",

  "Logs Audited": "Journaux audites",

  "# of Drivers": "# de Conducteurs",

  "# of Violations": "# de'infractions",

  "Int Location": "Int emplacement",

  "Drivers with HOS Violations": "Conducteurs avec des infractions de HOS",

  "Logs with HOS Violations": "Journaux avec des infractions de HOS",

  "Start": "DÉBUT",

  "No HOS Violations": "Aucune infraction de HOS",

  "No user found": "Aucun utilisateur trouvNon identifie",

  "Unidentified": "Non identifie",

  "Default Region": "Regoin par defaut",

  "Gorilla Safety Signed Contract 2021": "Contrat de GorillaSafety signe 2021",

  "New User Registered": "Nouvel utilisateur enregistre",

  "Registration Confirmation - FleetLocate": "Confirmation d'inscription - FleetLocate",

  "Your Gorilla Safety subscription for Company Name has been upgraded to Tier1 as per your request": "Votre abonnement de GorillaSafety pour Nom d'Entreprise a ete mis a niveau vers le niveau1 conformement a votre demande.",

  "Gorilla Safety Upgradation Successful": "Mise a niveau de GorillaSafetyreussie",

  "No subscription plan found for Fleetlocate": "Aucun plan d'abonnement trouve pour FleetLocate",

  "Invalid User Id!": "Indentifiant invalide!",

  "Not Connected": "Pas connecte",

  "Log Signed": "Journal signe",

  "Auto": "Auto",

  "Engine OFF": "Moteur ETEINT",

  "Engine ON": "Moteur ALLUME",

  "Adverse Driving Condition": "Cpondition de conduite defavorable",

  "No Remarks Found": "Aucune remarqu trouvee",

  "Illegal inspection type DVIR": "Type  d'inspection illegale DVIR",

  "DAILY LOG HISTORY": "Historique des journaux quotidiens",

  "ELD": "ELD details de deconenecte",

  "View Sample": "Voir un echantillon",

  "Back to Login": "Retour connexion",

  "Email address": "ADRESSE E-MAIL",

  "NB: This will send files to FMCSA via email or Web Services as outlined in Appendix A to Subpart B of Part 395": "NB : cela enverra les fichiers à la FMCSA par e-mail ou via les services Web, comme indiqué dans l'annexe A de la sous-partie B de la partie 395.",

  "Export": "Exportation",

  "Export Data": "Exporter les données",

  "Our apologies": "Nous excusons",

  "Please send us feedback": "Veuillez nous enboyer vos commentairs",

  "Corporate Office": "Bureau d'Entreprise",

  "Office": "Bureau",

  "Patent pending": "Brevet en instance",

  "Copyright 2020": "Droits d'auteur 2020",

  "Privacy & Legal": "Confidentialite et juriduque",

  "Spanish": "Espagnol",

  "DOT No.": "Numero de DOT",

  "MANAGE DAILY DOCUMENTS": "Gérer les documents quotidiens",

  "Compliance Notifications": "Avis de conformite",

  "Unhandled": "Non gere",

  "Date To": "Date a",

  "No data available in table": "Aucune donnee disponible",

  "coDriver Id": "ID du copilote",

  "The confirm password is not match with password": "Le mot de pass de confirmation ne correspond pas au mot de pass",

  "Please enter valid email format": "Veuillez entrer un format d'email valide",

  "Please enter a valid number": "Veuillez entrer un numero valide",

  "Must be greater than zero": "Doit etre superieur a zero",

  "Please enter no more than 10 characters": "Veuillez ne pas entrer plus de 10 caracteres",

  "Clear All": "Tout effacer",

  "Document": "Document",

  "User Credentials": "Informations d'identification de l'utilisateur",

  "Employee Id": "IDENTIFIANT DE L'EMPLOYÉ",

  "Departments": "SERVICES",

  "Vehicle ID": "ID DU VÉHICULE",

  "License Number": "NUMÉRO DE PERMIS",

  "Page not found": "Page introuvable",

  "USER MAIN INFORMATION": "Informations principales sur l'utilisateur",

  "Export All": "Tout exporter",

  "Please enter the same value again.": "Veuillez entrer a nouveau la meme valeur",

  "Region": "RÉGION",

  "Terminal": "TERMINAL",

  "Department": "SERVICE",

  "Dot Officer Code": "Code oficier DOT",

  "Please Select": "Veuillez selectionner",

  "Bulk Download Reports": "Rapports de telechargement groupe",

  "Import": "Importer",

  "Template": "Modele",

  "Are you sure?": "Etes-vous sur?",

  "You will not be able to recover this vehicle!": "Vous ne pourrez pas recuperer ce vehicule",

  "Device Type": "Type d'appareil invalide",

  "Policies and Procedures": "Les politiques et les procedures",

  "Other Contact": "AUTRES CONTACTS",

  "Next Maintenance Mileage": "PROCHAIN KILOMÉTRAGE D'ENTRETIEN",

  "Trailer Information": "Information de remorque",

  "Vehicle Information": "Information de vehicule",

  "Current Odometer": "ODOMÈTRE ACTUEL",

  "Hardware Device": "MATÉRIEL",

  "VIN number must be 17-character long. Numbers and letters only. I, O, or Q are not allowed": "Numero de VIN doit etre dix-sept caracteres.  Chiffres et lettres uniquement. I, O our Q sone pas autorises.",

  "Main Address": "Adresse principale",

  "Terminal Address": "Adresse du terminal",

  "Time Zone Offset From UTC": "DÉCALAGE DU FUSEAU HORAIRE PAR RAPPORT À L'UTC",

  "Location Of Log Signing": "Emplacement de la signature du journal",

  "Please enter at least 2 characters.": "Veuillez entrer au moin 2 caracteres",

  "Please fill in the correct format(844-636-1360).": "Merci de remplir le bon format",

  "Applied Filters :": "Filtres appliques:",

  "Daily Log for": "Journal quotiedien de:",

  "Refresh": "Refraichir",

  "You will not be able to recover this user!": "Vous ne pourrez pas recuperer cet utilisateur!",

  "You will activate this user!": "Vous allez activer cet utilisateur",

  "Minimum 1 row is required": "un minimum de 1 ligne est requis",

  "Yes, delete it!": "Oui,Supprimez-le",

  "Yes, accept it!": "Oui, acceptez-le",

  "Nothing to display": "ien a afficher",

  "Show": "Afficher",

  "Save Changes": "Enregistrer les modifications.",

  "Data has been imported successfully": "Les donnees on ete importees avec suces",

  "Please Accept Terms and Conditions To Continue": "Veuillez accepter les termes et conditions pour continuer",

  "User": "Utililisateur",

  "Driving state": "Etat de conduire",

  "Please select atleast one filter": "Veuillez selectionner au moins un filtre",

  "Name on Card": "Nom sur la carte",

  "No Data to plot": "Aucune donnée à représenter",

  "Please enter at least 4 characters.": "Veuillez entrer au moin 4 caracteres",

  "Please enter no more than 9 characters.": "Veuillez noe pas entrer plur de 9 caracteres",

  "Card Details Updated Successfully": "Details de las carte mis a jour avec succes",

  "USDOT Number deleted successfully": "Numero de USDOT supprime avec succes",

  "Region deleted successfully": "Region supprime avec succes",

  "Region added successfully": "Region ajoute avec succes",

  "Region updated successfully": "Region mise a jour avec succes",

  "Terminal added successfully": "Terminal ajoute avec succes",

  "Terminal updated successfully": "Terminal mis a jour avec succes",

  "Terminal deleted successfully": "Terminal supprime avec succes",

  "Department added successfully": "Departement ajoute avec succes",

  "Department updated successfully": "Departement mis a jour avec succes",

  "Department deleted successfully": "Departement suprime avec succes",

  "Location added successfully": "Emplacement ajoute avec succes",

  "Location updated successfully": "Emplacement mis a jour avec succes",

  "Location deleted successfully": "Emplacement supprime avec succes",

  "Parts added successfully": "Pieces ajoutees avec succes",

  "Summary": "Resume",

  "Print": "Imprimer",

  "No data available": "Pas de donnees disponibles",

  "Privacy Policy": "Politique de confidentialite",

  "Your account is not registered in Camera portal. Please register in camera portal and try again.": "Votre comte n'est pas enregistre dans le portail de l'appareil-photo.  Veuillez vous inscrire sure le portail de l'appareil-photo et reessayer.",

  "This feature is not configured for your account.": "Cette fonctionnalite n'est pas configuree pour votre compte",

  "Switch to New View": "Passer a un Nouvelle Vue",

  "Developer Permission Requests": "Demandes d'autorisation de developpeur",

  "IFTA Report": "Rapport de IFTA",

  "Fuel Consumption Report": "Rapport de consommation de carburant",

  "DOT Audit": "DOT AUDIT",

  "USDOT No. Management": "Gestion du numero USDOT",

  "Filters": "Filtres",

  "CSA Violations": "Infractions de CSA",

  "Camera": "CAMÉRA",

  "Companies": "Entreprises",

  "Freight": "Cargaison",

  "You have unassigned Unidentified Driving Time. Please go to the logs tab and assign these logs to the right driver.": "Vous avez un temps de conduite non identifie/non attribue.  Veuillez acceder a l'onglet journaux et attriguer ces journaux au bon conducteur.",

  "MANAGE USERS - ON DUTY": "GERER LES UTILISATEURS-EN SERVICE",

  "MANAGE USERS - SLEEPER": "GERER LES UTILISATEURS-COUCHETTE",

  "MANAGE USERS - OFF DUTY": "GERER LES UTILISATEURES-PAS EN SERVISE",

  "Driver Behavior": "Comportement du conducteur",

  "Vehicle Status": "Etat du vehicule",

  "Last Known Location": "Dernier emplacement connu",

  "Unit": "UNIT",

  "Drive Time Remaining": "Temps de conduite restant",

  "Time Until Break": "Temps jusqu'a la pause",

  "Duty Cycle Remaining": "Cycle de service restand",

  "Current Status": "Statut actuel",

  "Engine Speed": "Vitesse du moteur",

  "Last Updated": "Derniere mise a jour",

  "Drive Time": "Temps de conduite restant",

  "On Duty Time": "Temps en service",

  "Enable Notification": "Activer les notifications",

  "Manage Violations": "Gerer les infrations",

  "CSA Snapshot": "Instantane CSA",

  "Service Temporarily Unavailable": "Service Indisponibel Temporairement",

  "Internal server error": "Erreur interne du serveur",

  "Manage Companies": "Gerer des entreprises]",

  "WORK ORDER DETAILS": "Détails de l'ordre de travail",

  "Edit Trailer": "Modifier la remorque",

  "Vehicle for mechanic": "Véhicule pour le mécanicien",

  "Vehicle for driver": "Véhicule pour le conducteur",

  "Enable Non-DOT Trip": "Activer l'excursion non-DOT",

  "Enable Personal Conveyance": "Activer transport personnel",

  "Exempt from using ELD": "Exempte d'utiliser ELD",

  "Expiration": "Expiration",

  "View History": "Afficher l'historique",

  "Uploaded": "Téléchargée",

  "MM/DD/YYYY": "MM/JJ/AAAA",

  "View All": "Tout afficher",

  "Expiration Date": "Date d'expiration",

  "Select File to upload": "Sélectionnez le fichier à télécharger",

  "EDIT PROFILE": "Modifier le profil",

  "Driver Status History": "Historque de l'etat du conducteur",

  "Quick filters:": "Filtres rapides",

  "Service Managers": "Gestionnaires de services",

  "Manage Mechanics": "Gerer les mecaniciens",

  "Search Mechanic": "Chercher mecanicien",

  "Signed Logs": "Journaux signes",

  "Real-time/Unsigned Logs": "Temps reel/journaux non signes",

  "Unidentified driver logs": "Journaux de conduite non identifiés",

  "Add logs": "Ajouter des journaux",

  "Export dailylog signed status": "Exporter le statut signé du journal quotidien",

  "Unassigned Drive Time": "Temps de conduite non attribue",

  "Unidentified Driver Profile": "Profil de conducteur non identifie",

  "View Documents": "afficher les documents",

  "No violation data for the day": "Pas de donnee d'infraction pour le journee",

  "Refills History": "Historique des recharges",

  "Co-Driver Name": "Nom de copilote",

  "Log Signing Location": "Emplacement de signature du journal",

  "Verification Status": "Etat de verification",

  "State Modifier": "Modificateur d'etat",

  "Time From": "Heure de",

  "Time To": "Heure a",

  "Latest Fueling Location": "Dernier point de revitaillement",

  "Add new row": "Ajouter nouveau ligne",

  "Update events": "Mettre a jour les evenements",

  "Update Graph": "Mettre a jour le graphique",

  "Invalid request. Click here to go back to dashboard": "Demand invalide.  Cliques ici pour revenir au tableau de bord",

  "GO BACK": "RETOURNER",

  "Emp Id": "EMP ID",

  "Import User Template": "Importer des modeles d'utilisateur",

  "Export Users": "Exporter des utilisateurs",

  "Yes, deactivate user!": "Oui, desactiver l'utilisateur!",

  "Yes, activate it!": "Oui, activez-le!",

  "Manufact": "Fabrication",

  "List of Trailers": "Liste des remorques",

  "Roadside Inspections": "Inspection routiere",

  "Export Vehicles": "Exporter vehicules",

  "Export Trailers": "Exporter les bandes-annonces",

  "Import Vehicles Template": "Modele d'importation de vehicules",

  "Import Trailers Template": "Modele d'importation de remorques",

  "Track Vehicle": "Traquer le vehicule",

  "Date/Time From": "Date/ heure de",

  "Date/Time To": "Date/heure a",

  "Seat Belt Status": "Etat de la ceinture de securite",

  "Send message": "Envoyer message",

  "To: Search...": "A: Chercher",

  "New Conversation": "Nouvelle conversation",

  "Broadcast": "Diffuser",

  "You will not be able to recover this trailer!": "Vous ne pourrez pas recuperer ce remorque!",

  "Driver ID": "Identifiant du conducteur",

  "Defect Found": "Defaut trouve",

  "Download Reports": "telecharger les rapports",

  "View Witnesses": "Voir les temoins",

  "View Receipt": "Voir le recu",

  "Developer Name": "Nom du developpeur",

  "Terminals and Departments": "Terminaux et Departements",

  "No location added": "Aucun emplacement ajoute",

  "No departments under this terminal": "Aucun departement sous ce terminal",

  "Add Terminal": "Ajouter terminal",

  "Edit Terminal": "Editer terminal",

  "Add Region": "Ajouter region",

  "Edit Region": "Editer region",

  "Region Name": "Nom de region",

  "Add Department": "Ajouter departement",

  "Edit Department": "Editer departement",

  "Add Location": "Ajouter Emplacement",

  "Edit Location": "Editer Emplace ment",

  "Delete Terminal": "Effacer Terminal",

  "Delete Department": "Effacer Departement",

  "Service Centers": "Centres de Service",

  "Set Filter": "Definir le filtre",

  "FLEET MANAGER INFORMATION": "Informations sur le gestionnaire de flotte",

  "Maintenance Period (Months)": "Période de maintenance (mois)",

  "Subscription Tier": "Niveau d'abonnement",

  "Contract Length": "La duree du contrat",

  "Create Account": "Creer un comte",

  "Producer Code": "Code de producteur",

  "I agree to the": "Je suis d'accord au",

  "Terms of Use": "Conditions d'utilisation",

  "Total amount: $": "Montant total: $",

  "PAYMENT CONFIRMATION": "Confirmation de paiement",

  "Sales Tax ($)": "Taxe de vente ($)",

  "Discount (%) (if any)": "Reduction (%) le cas echeant",

  "Total Amount ($)": "Montant total ($)",

  "I accept the following terms and conditions.": "J'accepte les termes et conditions suivants",

  "DVIR Link": "Lien de DVIR",

  "DVIR Status": "Statue de DVIR",

  "Roadside DOT Inspection": "Inspection DOT routiere",

  "Work Order": "Demande de service",

  "Work Order Status": "Statut de demand de service",

  "OOS": "OOS",

  "Severity": "Gravite",

  "Download Truck GPS history": "Telecharger l'historique GPS du camion",

  "Hide States with no mileage": "Masquer les etats sans kilometrage",

  "Active Vehicles": "Vehicules actives",

  "Deactivated Vehicles": "Vehicules desactives",

  "Total Miles": "Milles totaus",

  "Jurisdiction": "JURIDICTION",

  "Current Drivers": "Conducteurs actuels",

  "Miles per Gallon": "Milles par gallon",

  "Gallons": "Gallons",

  "USDot No.": "Numero de DOT de EU",

  "Name of Carrier": "Nom de transporteur",

  "Main Office Address": "Adresse au bureau principas",

  "Zip": "Code postal",

  "ADD NEW DOT": "Ajouter un nouveau DOT",

  "EDIT DOT": "Modifier le DOT",

  "Message": "Messagerie",

  "Search By User": "Cherchez par utilisateur",

  "Inspection Type": "Type d'inspection",

  "Inspection Reports": "Rapport d'inspection",

  "Advanced DVIR": "DVIR avancé",

  "Bulk Download Report": "Rapport de telechargement groupe",

  "Section": "Section",

  "Configuration type or section name not entered": "Type de configuration ou nom de section non entre",

  "Custom DVIR": "DVIR personnalise",

  "Search By Company": "Chercher par Entreprise",

  "Search By Mechanic": "Chercher par Mecanicien",

  "Has Defects?": "A des defauts?",

  "Work Order #": "Numero de demande de service",

  "Reported Date": "Date rapportee",

  "Scheduled Date": "Date etabli",

  "Repair Cost($)": "Cout de reparation",

  "Open WorkOrders": "Ordres de travail ouverts",

  "Closed WorkOrders": "Ordres de travail clôturés",

  "Add WorkOrder": "Ajouter un ordre de travail",

  "Unit Type": "Type d'unite",

  "INSPECTION DETAILS": "Détails de l'inspection",

  "Labor Cost ($)": "COÛT DE MAIN-D'ŒUVRE ($)",

  "Parts Cost ($)": "COÛT DES PIÈCES ($)",

  "Total Cost ($)": "COÛT TOTAL ($)",

  "View Picture": "Voir photo",

  "No Report": "Aucun rapport",

  "Assign to another Service Center": "Affecter a un autre centre de service",

  "Assign Service Request": "Affecter demand de service",

  "Service Request assigned to a service center. Unable to make this change!": "Demand de service attribuee a un centre de service.  Impossible d'effectuer cette modification",

  "Work Order Has Been Updated.": "Ordre de travail a ete mis a jour",

  "Service Repair Request Has Been Updated.": "La demande de reparation de service a ete mise a jour",

  "# in Inventory": "# en inventaire",

  "Cost Per Unit": "Cout par unite",

  "Add Part": "Ajouter piece",

  "Please enter a value greater than or equal to 0.": "Veuillez entrer une valeur supieure a out egale a 0",

  "Maintenance Period": "periode de maintenance",

  "Other Location Contact Person": "Personne-ressource d'autre endroit",

  "Other Location Address": "Adress d'autre endroit",

  "Other Location Phone Number": "Numero de telephone d'autre endroit",

  "Default Cycle Rule": "RÈGLE DE CYCLE PAR DÉFAUT",

  "Payment Information": "Information de paiement",

  "Cancel Subscription": "Annuler l'abonnement",

  "Update Credit Card Details": "Mettre a jour les details de la carte de credit",

  "Skip Vehicle Filter Search": "ignorer la recherche de remplissage de vehicule",

  "Enable Oil Field Waiting": "Activer en attente - champ petrolifere",

  "Advance Settings": "Parametres avances",

  "IFTA": "IFTA",

  "Company Info for": "Information pour l'Entreprise",

  "Contract History": "Histoire de contrat",

  "Contract Start Date": "Date de debut du contrat",

  "Next Billing Date": "Prochaine date de Facturation",

  "Payment History for Test Tracks Company": "Historique des paiements pour la societe de pistes d'essai",

  "Created Date": "Date de creation",

  "Paid Date": "Date de paiement",

  "Unit Count": "Nombre d'unites",

  "Start Date": "DATE DE DÉBUT",

  "End Date": "DATE DE FIN",

  "No.Of Days": "Numero de jours",

  "Pay With Card": "Payer avec carte",

  "Payment Details": "DÉTAILS DU PAIEMENT",

  "You have active contract from": "Vous avez un cotrat actif de:",

  "Document Type": "Type de document",

  "Customer Name/Job Name": "Nom du client/nom du travail",

  "Duty Status": "Statut de service",

  "Driver Performance Report": "RAPPORT DE PERFORMANCE DU CONDUCTEUR",

  "Edited Data Report": "Rapport de donnees edite",

  "Rejected Edits": "Modification rejetees",

  "ELD Disconnect Report": "RAPPORT DE DÉCONNEXION DE L'ELD",

  "Unassigned Driving Report": "RAPPORT DE CONDUITE NON ATTRIBUÉ",

  "HOS Violations Details": "Details d'infractions HOW",

  "Bill Of lading Report": "Rapport de connaissement",

  "HOS Violations Report": "Rapport d'infractions HOS",

  "Unsigned Log Report": "Rapport de journal non signe",

  "Failed Inspection Report": "Echec du rapport d'inspection",

  "Unidentified driving report": "Rapport de conduite non identifie",

  "Monthly HOS Driver Violations Report": "Rapport mensuel des infractions HOS de conducteur",

  "Monthly Unsigned Log report": "Rapport mensuel de journaux pas signes",

  "Hard Acceleration": "Acceleration forte",

  "Hard Deceleration": "Deceleration forte",

  "Speeding": "Exces de vitesse",

  "Driving Hours Exceeded": "Heures de conduite depasses",

  "Fuel Economy": "Economie de carburant",

  "Non Buckled Seat Belt Warning": "Avertissment de ceinture de securite non bouclee",

  "Hard Turn": "Virage forte",

  "to go back to Inspections": "Retourner aux inspections",

  "Search Companies": "Chercher des entreprises",

  "Area": "Region",

  "Comments by Mechanic": "COMMENTAIRES DU MÉCANICIEN",

  "Comment": "Commentaire",

  "Fix Status": "Regler statut",

  "View Photo": "Voir photo",

  "RIGHTS AND TERMS FOR APP": "DROITS ET CONDITIONS DE L'APP",

  "General Prohibitions": "Interdictions generales",

  "IT IS STRICTLY FORBIDDEN TO USE THE CLUTCHELD APP WHILE DRIVING": "IL EST STRICTEMENT INTERDIT D'TILISER L'APPLICATION CLUTCHELD PENDANT LA CONDUITE",

  "You further agree not to do any of the following:": "Vous acceptez en outre de ne faire aucune des choses suivants",

  "1. Post, upload, publish, submit or transmit any User Content that: (in) infringes, misappropriates or violates a third party's patent, copyright, trademark, trade secret, moral rights or other intellectual property rights, or rights of publicity or privacy; (ii) violates, or encourages any conduct that would violate, any applicable law or regulation or would give rise to civil liability; (iii) is fraudulent, false, misleading or deceptive; (iv) is defamatory, obscene, pornographic, vulgar or offensive; (v) promotes discrimination, bigotry, racism, hatred, harassment or harm against any individual or group; (vi) is violent or threatening or promotes violence or actions that are threatening to any person or entity; or (vii) promotes illegal or harmful activities or substances. 2. Use, display, mirror or frame the Services, or any individual element within the Services, ClutchELD's name, any ClutchELD trademark, logo or other proprietary information, or the layout and design of any page or form contained on a page, without ClutchELD's express written consent; 3. Access, tamper with, or use non-public areas of the Services, ClutchELD's computer systems, or the technical delivery systems of ClutchELD's providers; 4. Attempt to probe, scan, or test the vulnerability of any ClutchELD system or network or breach any security or authentication measures; 5. Avoid, bypass, remove, deactivate, impair, descramble or otherwise circumvent any technological measure implemented by ClutchELD or any of ClutchELD's providers or any other third party (including another user) to protect the Services or User Content; 6. Attempt to access or search the Services or User Content or download User Content from the Services through the use of any engine, software, tool, agent, device or mechanism (including spiders, robots, crawlers, data mining tools or the like) other than the software and/or search agents provided by ClutchELD or other generally available third party web browsers; 7. Send any unsolicited or unauthorized advertising, promotional materials, email, junk mail, spam, chain letters or other form of solicitation; 8. Use any meta tags or other hidden text or metadata utilizing a ClutchELD trademark, logo, URL or product name without ClutchELD's express written consent; 9. Use the Services or User Content for the benefit of any third party or in any manner not permitted by these Terms; 10. Forge any TCP/IP packet header or any part of the header information in any email or newsgroup posting, or in any way use the Services or User Content to send altered, deceptive or false source-identifying information; 11. Attempt to decipher, decompile, disassemble or reverse engineer any of the software used to provide the Services or User Content; 12. Interfere with, or attempt to interfere with, the access of any user, host or network, including, without limitation, sending a virus, overloading, flooding, spamming, or mail-bombing the Services; 13. Collect or store any personally identifiable information from the Services from other users of the Services without their express permission; 14. Impersonate or misrepresent your affiliation with any person or entity; 15. Violate any applicable law or regulation; or 16. Encourage or enable any other individual to do any of the foregoing.": "1. Publier, télécharger, publier, soumettre ou transmettre tout Contenu utilisateur qui : (in) enfreint, détourne ou viole le brevet, le droit d'auteur, la marque commerciale, le secret commercial, les droits moraux ou autres droits de propriété intellectuelle, ou les droits de publicité ou de confidentialité d'un tiers ; (ii) viole ou encourage toute conduite qui violerait toute loi ou réglementation applicable ou donnerait lieu à une responsabilité civile ; (iii) est frauduleux, faux, trompeur ou mensonger ; (iv) est diffamatoire, obscène, pornographique, vulgaire ou offensant ; (v) incite à la discrimination, au fanatisme, au racisme, à la haine, au harcèlement ou à des atteintes à l'encontre de tout individu ou groupe ; (vi) est violent ou menaçant ou encourage la violence ou des actions qui menacent toute personne ou entité ; ou (vii) fait la promotion d'activités ou de substances illégales ou nuisibles. 2. Utiliser, afficher, refléter ou encadrer les Services, ou tout élément individuel des Services, le nom de ClutchELD, toute marque, logo ou autre information exclusive de ClutchELD, ou la mise en page et la conception de toute page ou formulaire contenu sur une page, sans l'accord de ClutchELD. consentement écrit exprès; 3. Accéder, altérer ou utiliser des zones non publiques des Services, des systèmes informatiques de ClutchELD ou des systèmes techniques de livraison des fournisseurs de ClutchELD ; 4. Tenter de sonder, analyser ou tester la vulnérabilité de tout système ou réseau ClutchELD ou enfreindre toute mesure de sécurité ou d'authentification ; 5. Éviter, contourner, supprimer, désactiver, altérer, désembrouiller ou autrement contourner toute mesure technologique mise en œuvre par ClutchELD ou l'un des fournisseurs de ClutchELD ou tout autre tiers (y compris un autre utilisateur) pour protéger les Services ou le Contenu utilisateur ; 6. Tenter d'accéder ou de rechercher les Services ou le Contenu utilisateur ou de télécharger du Contenu utilisateur à partir des Services via l'utilisation de tout moteur, logiciel, outil, agent, dispositif ou mécanisme (y compris les araignées, les robots, les robots, les outils d'exploration de données ou similaires) autre que le logiciel et/ou les agents de recherche fournis par ClutchELD ou d'autres navigateurs Web tiers généralement disponibles ; 7. Envoyer des publicités non sollicitées ou non autorisées, du matériel promotionnel, des e-mails, des courriers indésirables, des spams, des chaînes de lettres ou toute autre forme de sollicitation ; 8. Utiliser des balises méta ou tout autre texte caché ou métadonnée utilisant une marque, un logo, une URL ou un nom de produit ClutchELD sans le consentement écrit exprès de ClutchELD ; 9. Utiliser les Services ou le Contenu utilisateur au profit d'un tiers ou d'une manière non autorisée par les présentes Conditions ; 10. Falsifier tout en-tête de paquet TCP/IP ou toute partie des informations d'en-tête dans tout e-mail ou publication de groupe de discussion, ou utiliser de quelque manière que ce soit les Services ou le Contenu utilisateur pour envoyer des informations d'identification de source modifiées, trompeuses ou fausses ; 11. Tenter de déchiffrer, décompiler, désassembler ou désosser tout logiciel utilisé pour fournir les Services ou le Contenu utilisateur ; 12. Interférer ou tenter d'interférer avec l'accès de tout utilisateur, hôte ou réseau, y compris, sans s'y limiter, l'envoi d'un virus, la surcharge, l'inondation, le spam ou le mail-bombing des Services ; 13. Recueillir ou stocker toute information personnellement identifiable des Services d'autres utilisateurs des Services sans leur autorisation expresse ; 14. Usurper l'identité ou déformer votre affiliation avec toute personne ou entité ; 15. Violer toute loi ou réglementation applicable ; ou 16. Encourager ou permettre à toute autre personne de faire tout ce qui précède.",

  "Although we're not obligated to monitor access to or use of the Services or User Content or to review or edit any User Content, we have the right to do so for the purpose of operating the Services, to ensure compliance with these Terms, or to comply with applicable law or other legal requirements. We reserve the right, but are not obligated, to remove or disable access to any User Content, at any time and without notice, including, but not limited to, if we, at our sole discretion, consider any User Content to be objectionable or in violation of these Terms. We have the right to investigate violations of these Terms or conduct that affects the Services. We may also consult and cooperate with law enforcement authorities to prosecute users who violate the law.": "Bien que nous ne soyons pas obligés de surveiller l'accès ou l'utilisation des Services ou du Contenu de l'utilisateur ou de réviser ou de modifier tout Contenu de l'utilisateur, nous avons le droit de le faire dans le but d'exploiter les Services, d'assurer le respect des présentes Conditions, ou pour se conformer à la loi applicable ou à d'autres exigences légales. Nous nous réservons le droit, mais ne sommes pas obligés, de supprimer ou de désactiver l'accès à tout Contenu utilisateur, à tout moment et sans préavis, y compris, mais sans s'y limiter, si nous, à notre seule discrétion, considérons que tout Contenu utilisateur est répréhensible ou en violation des présentes Conditions. Nous avons le droit d'enquêter sur les violations de ces Conditions ou sur les comportements qui affectent les Services. Nous pouvons également consulter et coopérer avec les autorités chargées de l'application de la loi pour poursuivre les utilisateurs qui enfreignent la loi.",

  "Termination ClutchELD may terminate your access to and use of the Services, at our sole discretion, at any time and without notice to you. You may cancel your Account at any time by sending an email to us at support@clutcheld.com. Upon any termination, discontinuation or cancellation of Services or your Account, the following provisions will survive: Third Parties; User Content Rights; No Warranty; Indemnity; Limitation of Liability; Choice of Law; Arbitration; and General Terms. At the time of cancellation you will be responsible for any obligations agreed to under the applicable Sales Agreement, to the extent they are validly existing.": "Résiliation ClutchELD peut résilier votre accès et votre utilisation des Services, à notre seule discrétion, à tout moment et sans préavis. Vous pouvez annuler votre compte à tout moment en nous envoyant un e-mail à support@clutcheld.com. En cas de résiliation, d'interruption ou d'annulation des Services ou de votre Compte, les dispositions suivantes survivront : Tiers ; Droits sur le contenu de l'utilisateur ; Aucune garantie; Indemnité; Limitation de responsabilité; Choix de la loi; Arbitrage; et Conditions Générales. Au moment de l'annulation, vous serez responsable de toutes les obligations convenues en vertu du contrat de vente applicable, dans la mesure où elles existent valablement.",

  "No Warranty": "Warranty forte",

  "THE SERVICES AND USER CONTENT ARE PROVIDED 'AS IS' WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE FOREGOING, CLUTCHELD EXPLICITLY DISCLAIMS ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT AND NON-INFRINGEMENT AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE. CLUTCHELD EXPLICITLY DISCLAIMS ALL LIABILITY FOR ANY ACT OR OMISSION OF ANY USER OR OTHER THIRD PARTY. WITHOUT LIMITING THE FOREGOING, CLUTCHELD MAKES NO WARRANTY THAT (I) THE SERVICES WILL MEET YOUR REQUIREMENTS OR WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERRORFREE; (II) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICES WILL BE EFFECTIVE, ACCURATE OR RELIABLE; (III) THE QUALITY OF THE SERVICES WILL MEET YOUR EXPECTATIONS; OR THAT (IV) ANY ERRORS OR DEFECTS IN THE SERVICES WILL BE CORRECTED. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM CLUTCHELD OR THROUGH OR FROM USE OF THE SERVICES SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE TERMS.": "LES SERVICES ET LE CONTENU UTILISATEUR SONT FOURNIS \"TELS QUELS\" SANS GARANTIE D'AUCUNE SORTE. SANS LIMITER CE QUI PRÉCÈDE, CLUTCHELD DÉCLINE EXPLICITEMENT TOUTE GARANTIE IMPLICITE DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER, DE JOUISSANCE PAISIBLE ET D'ABSENCE DE CONTREFAÇON ET TOUTE GARANTIE DÉCOULANT DU COURS DES AFFAIRES OU DE L'USAGE DU COMMERCE. CLUTCHELD DÉCLINE EXPLICITEMENT TOUTE RESPONSABILITÉ POUR TOUT ACTE OU OMISSION DE TOUT UTILISATEUR OU AUTRE TIERS. SANS LIMITER CE QUI PRÉCÈDE, CLUTCHELD NE GARANTIT PAS QUE (I) LES SERVICES RÉPONDRONT À VOS EXIGENCES OU SERONT ININTERROMPUS, OPPORTUNS, SÉCURISÉS OU SANS ERREUR ; (II) LES RÉSULTATS POUVANT ÊTRE OBTENUS DE L'UTILISATION DES SERVICES SERONT EFFICACES, EXACTS OU FIABLES ; (III) LA QUALITÉ DES SERVICES RÉPONDRA À VOS ATTENTES ; OU QUE (IV) TOUTE ERREUR OU DÉFAUT DANS LES SERVICES SERA CORRIGÉ. AUCUN CONSEIL OU INFORMATION, ORAL OU ÉCRIT, OBTENU PAR VOUS DE CLUTCHELD OU PAR L'UTILISATION DES SERVICES NE CONSTITUE UNE GARANTIE NON EXPRESSÉMENT STIPULÉE DANS LES CONDITIONS.",

  "CLUTCHELD IS NOT RESPONSIBLE FOR THE CONDUCT OF ANY USER. YOUR USE OF THE SERVICES IS AT YOUR SOLE RISK AND DISCRETION AND CLUTCHELD HEREBY DISCLAIMS ANY AND ALL LIABILITY TO YOU OR ANY THIRD PARTY RELATING THERETO.": "CLUTCHELD N'EST PAS RESPONSABLE DE LA CONDUITE D'UN UTILISATEUR. VOTRE UTILISATION DES SERVICES EST À VOS PROPRES RISQUES ET DISCRÉTION ET CLUTCHELD DÉCLINE PAR LA PRÉSENTE TOUTE RESPONSABILITÉ ENVERS VOUS OU TOUT TIERS EN RAPPORT.",

  "Indemnity You agree to indemnify, defend and hold harmless ClutchELD and its officers, directors, employees and agents, from and against, all claims, disputes, demands, liabilities, damages, losses, and costs and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with (i) your access to or use of the Services; (ii) your User Content; (iii) your performance of or participation in connection with your use of the Services; or (iv) your violation of these Terms.": "Indemnité Vous acceptez d'indemniser, de défendre et d'exonérer ClutchELD et ses dirigeants, administrateurs, employés et agents, de et contre, toutes les réclamations, litiges, demandes, responsabilités, dommages, pertes et coûts et dépenses, y compris, sans s'y limiter, les frais juridiques raisonnables. et les frais de comptabilité, découlant de ou liés de quelque manière que ce soit à (i) votre accès ou votre utilisation des Services ; (ii) votre Contenu Utilisateur ; (iii) votre performance ou votre participation dans le cadre de votre utilisation des Services ; ou (iv) votre violation de ces Conditions.",

  "Limitation of Liability": "Limitation de responsabilité",

  "NEITHER CLUTCHELD NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE SERVICES OR USER CONTENT WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOSS OF DATA OR GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF SUBSTITUTE SERVICES ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE SERVICES OR USER CONTENT, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT CLUTCHELD HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU.": "NI CLUTCHELD NI AUCUNE AUTRE PARTIE IMPLIQUÉE DANS LA CRÉATION, LA PRODUCTION OU LA FOURNITURE DES SERVICES OU DU CONTENU UTILISATEUR NE SERA RESPONSABLE DE TOUT DOMMAGE ACCESSOIRE, SPÉCIAL, EXEMPLAIRE OU CONSÉCUTIF, Y COMPRIS LA PERTE DE PROFITS, LA PERTE DE DONNÉES OU DE BONNE VOLONTÉ, L'INTERRUPTION DE SERVICE, LES DOMMAGES INFORMATIQUES OU LE SYSTÈME. L'ÉCHEC OU LE COÛT DES SERVICES DE SUBSTITUTION RÉSULTANT DE OU EN RELATION AVEC CES CONDITIONS OU DE L'UTILISATION OU DE L'INCAPACITÉ D'UTILISER LES SERVICES OU LE CONTENU UTILISATEUR, QU'ILS SONT BASÉS SUR LA GARANTIE, LE CONTRAT, LE DÉLIT (Y COMPRIS LA NÉGLIGENCE), LA RESPONSABILITÉ DU PRODUIT OU TOUTE AUTRE LÉGAL THÉORIE, ET SI CLUTCHELD A ÉTÉ INFORMÉ OU NON DE LA POSSIBILITÉ DE TELS DOMMAGES, MÊME SI UN RECOURS LIMITÉ ÉNONCÉ DANS LES PRÉSENTES EST DÉCLARÉ QU'IL N'A PAS RÉALISÉ SON OBJECTIF ESSENTIEL. CERTAINES JURIDICTIONS N'AUTORISENT PAS L'EXCLUSION OU LA LIMITATION DE RESPONSABILITÉ POUR LES DOMMAGES INDIRECTS OU ACCESSOIRES, LA LIMITATION CI-DESSUS PEUT NE PAS S'APPLIQUER À VOUS.",

  "CLUTCHELD WILL NOT BE LIABLE TO YOU UNDER ANY CIRCUMSTANCES ARISING OUT OF THE MISUSE OF YOUR USER CONTENT BY THIRD PARTIES INCLUDING, WITHOUT LIMITATION, OTHER USERS.": "Exces de vitesse",

  "In no event will ClutchELD's total liability arising out of or in connection with these terms or from the use of or inability to use the Services or User Content exceed fifty dollars ($50), or the amount paid by you to ClutchELD during the preceding six (6) month period for use of the Services, whichever is greater.": "En aucun cas, la responsabilité totale de ClutchELD découlant de ou en relation avec ces conditions ou de l'utilisation ou de l'impossibilité d'utiliser les Services ou le Contenu utilisateur ne dépassera cinquante dollars (50 $), ou le montant que vous avez payé à ClutchELD au cours des six ( 6) mois d'utilisation des Services, selon la période la plus longue.",

  "Choice of Law; Arbitration This Agreement is subject to the law of the State of Texas, United States, without regard to choice or conflicts of law principles. Further, you agree to the exclusive jurisdiction of the state and federal courts in Harris County, Texas to resolve any dispute, claim or controversy that arises in connection with this Agreement.": "Choix de la loi; Arbitrage Le présent accord est soumis à la loi de l'État du Texas, aux États-Unis, sans égard au choix ou aux principes de conflits de lois. En outre, vous acceptez la compétence exclusive des tribunaux d'État et fédéraux du comté de Harris, au Texas, pour résoudre tout litige, réclamation ou controverse découlant du présent accord.",

  "The following mandatory arbitration provisions also apply to you:": "Les dispositions d'arbitrage obligatoires suivantes s'appliquent également à vous :",

  "1. You and ClutchELD agree that any dispute, claim or controversy arising out of or relating in any way to the ClutchELD Service or your use thereof, including our Agreements, shall be determined by mandatory binding arbitration. You and ClutchELD are each waiving the right to a trial by jury and the right to participate in a class or multi-party action. This arbitration provision shall survive": "1. Vous et ClutchELD acceptez que tout litige, réclamation ou controverse découlant de ou lié de quelque manière que ce soit au Service ClutchELD ou à votre utilisation de celui-ci, y compris nos Accords, sera déterminé par arbitrage exécutoire obligatoire. Vous et ClutchELD renoncez chacun au droit à un procès devant jury et au droit de participer à un recours collectif ou multipartite. Cette clause d'arbitrage survivra",

  "termination of these Agreements and the termination of your account with ClutchELD. The arbitration will be governed by the American Arbitration Association (the “AAA Rules”), as modified by this Agreement, and as administered by the AAA. You and ClutchELD agree that this Agreement may involve interstate commerce and may be subject to the Federal Arbitration Act. 2. Any arbitration must be commenced by filing a demand for arbitration with the AAA within ONE (1) YEAR after the date the party asserting the claim first knows or reasonably should know of the act, omission or default giving rise to the claim; and there shall be no right to any remedy for any claim not asserted within that time period. If applicable law prohibits a one-year limitations period for asserting claims, any claim must be asserted within the shortest time period permitted by applicable law. The findings of the arbitrator shall be final and binding on the parties, and may be entered in any court of competent jurisdiction for enforcement. Notwithstanding the law of Texas, legal fees shall be awarded to the prevailing party in the arbitration.": "la résiliation de ces accords et la résiliation de votre compte avec ClutchELD. L'arbitrage sera régi par l'American Arbitration Association (les «règles AAA»), telles que modifiées par le présent accord, et administrées par l'AAA. Vous et ClutchELD convenez que le présent Accord peut impliquer un commerce interétatique et peut être soumis à la loi fédérale sur l'arbitrage. 2. Tout arbitrage doit être commencé par le dépôt d'une demande d'arbitrage auprès de l'AAA dans un délai d'UN (1) AN après la date à laquelle la partie faisant valoir la réclamation a connaissance ou devrait raisonnablement avoir connaissance de l'acte, de l'omission ou du manquement donnant lieu à la réclamation ; et il n'y aura aucun droit à un recours pour toute réclamation non revendiquée dans ce délai. Si la loi applicable interdit un délai de prescription d'un an pour faire valoir des réclamations, toute réclamation doit être faite dans le délai le plus court autorisé par la loi applicable. Les conclusions de l'arbitre sont définitives et contraignantes pour les parties, et peuvent être portées devant tout tribunal compétent pour exécution. Nonobstant la loi du Texas, les frais juridiques seront attribués à la partie gagnante de l'arbitrage.",

  "General Terms These Terms constitute the entire and exclusive understanding and agreement between ClutchELD and you regarding the Services and User Content, and these Terms supersede and replace any and all prior oral or written understandings or agreements between ClutchELD and you regarding the Services and User Content. If for any reason a court of competent jurisdiction finds any provision of these Terms invalid or unenforceable, that provision will be enforced to the maximum extent permissible and the other provisions of these Terms will remain in full force and effect.": "Conditions générales Ces conditions constituent l'entente et l'accord entiers et exclusifs entre ClutchELD et vous concernant les services et le contenu utilisateur, et ces conditions annulent et remplacent toutes les ententes ou accords oraux ou écrits antérieurs entre ClutchELD et vous concernant les services et le contenu utilisateur. Si, pour quelque raison que ce soit, un tribunal compétent juge qu'une disposition des présentes Conditions est invalide ou inapplicable, cette disposition sera appliquée dans toute la mesure permise et les autres dispositions des présentes Conditions resteront en vigueur et de plein effet.",

  "You may not assign or transfer these Terms, by operation of law or otherwise, without ClutchELD's prior written consent. Any attempt by you to assign or transfer these Terms, without such consent, will be null and of no effect. ClutchELD may freely assign or transfer these Terms without restriction. Subject to the foregoing, these Terms will bind and inure to the benefit of the parties, their successors and permitted assigns": "Vous ne pouvez pas céder ou transférer ces Conditions, par effet de la loi ou autrement, sans le consentement écrit préalable de ClutchELD. Toute tentative de votre part de céder ou de transférer ces Conditions, sans un tel consentement, sera nulle et sans effet. ClutchELD peut librement céder ou transférer ces Conditions sans restriction. Sous réserve de ce qui précède, les présentes conditions lieront et s'appliqueront au profit des parties, de leurs successeurs et ayants droit autorisés.",

  "Any notices or other communications provided by ClutchELD under these Terms, including those regarding modifications to these Terms, will be given by ClutchELD via email. For notices made by e-mail, the date of receipt will be deemed the date on which such notice is transmitted.": "Tout avis ou autre communication fourni par ClutchELD en vertu des présentes Conditions, y compris ceux concernant les modifications de ces Conditions, sera envoyé par ClutchELD par e-mail. Pour les notifications faites par e-mail, la date de réception sera considérée comme la date à laquelle cette notification est transmise.",

  "ClutchELD's failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. The waiver of any such right or provision will be effective only if in writing and signed by a duly authorized representative of ClutchELD. Except as expressly set forth in these Terms, the exercise by either party of any of its remedies under these Terms will be without prejudice to its other remedies under these Terms or otherwise.": "L'incapacité de ClutchELD à faire respecter un droit ou une disposition des présentes Conditions ne sera pas considérée comme une renonciation à ces droits. La renonciation à un tel droit ou disposition ne sera effective que si elle est écrite et signée par un représentant dûment autorisé de ClutchELD. Sauf indication expresse dans les présentes Conditions, l'exercice par l'une ou l'autre des parties de l'un de ses recours en vertu des présentes Conditions sera sans préjudice de ses autres recours en vertu des présentes Conditions ou autrement.",

  "Contract Length (Years)": "Duration du contrat",

  "Fleet Drivers": "Conducteurs de la flotte",

  "Fleet Vehicles": "Vehicules de la flotte",

  "Report From Gorilla": "Rapport de Gorilla",

  "Hello, there is document for you!": "Bonjour, il y a un document pour vous",

  "Please contact your fleet manager about enabling the messaging feature.": "Veuillez contacter votre gestionnaire de flotte pour activer la fonction de messagerie.",

  "Vehicle Coordinates saved successfully": "Coordonnées du véhicule enregistrées avec succès",

  "Unauthorized": "Pas autorise",

  "Reports From Fleetlocate": "Rapports de Fleetlocate",

  "Hello, there are some docs for you!": "Bonjour, il y a des documents  pour vous",

  "Bad Request": "Mauvais demande",

  "Exception occured": "Une exception s'est produite",

  "Failed to assign Co-driver": "Échec de l'attribution du copilote",

  "No Content": "Pas de contenu",

  "Event type is mandatory.": "Le type d'événement est obligatoire",

  "Event date and time is mandatory.": "Date et heure d'evenement est obligatoire",

  "Driver Id is mandatory.": "L'ID du conducteur est obligatoire",

  "Driver Id should be numeric": "ID du conducteur doit etre numerique",

  "Vehicle Id is mandatory.": "ID de la vehicule est obligatoire",

  "Vehicle Id should be numeric": "ID de la vehicule doit etre numerique",

  "Hardware type is mandatory.": "Le type de matériel est obligatoire.",

  "Company found": "Entreprise pas trouve",

  "No companies found": "Aucun entreprise trouve",

  "No vehicle assigned for the user": "Aucun véhicule attribué à l'utilisateur",

  "Logged in Successfully": "Connecté avec succès",

  "Please enter a registered email address": "Veuillez saisir une adresse e-mail enregistrée",

  "Your login is already in use, do you want to logout another user and login?": "Votre identifiant est déjà utilisé, voulez-vous déconnecter un autre utilisateur et vous connecter ?",

  "User does not exist in the system.": "L'utilisateur n'existe pas dans le système.",

  "Pending requests for mobile debug log does not exist for User User1": "La demande de journaux de débogage mobile n'existe pas pour l'utilisateur.",

  "Mobile debug logs request does not exist for user.": "Les pièces ont été ajoutées avec succès",

  "Successfully Added The Parts": "Les pièces ont été ajoutées avec succès",

  "Rated Successfully": "Évalué avec succès",

  "No such vehicle": "Aucun véhicule de ce type",

  "Approval": "Approbation",

  "Co drivers": "Copilotes",

  "Bad date format": "Mauvais format de date",

  "WorkOrder not found for this user and id": "WorkOrder introuvable pour cet utilisateur et cet identifiant",

  "There was an issue retrieving this file. Please try again later.": "Un problème est survenu lors de la récupération de ce fichier. Veuillez réessayer plus tard.",

  "An error occurred while sending logs": "Une erreur s'est produite lors de l'envoi des journaux",

  "Indicates out of service": "Indique hors service",

  "Add Trailer remarks": "Ajouter des remarques sur la remorque",

  "Select Trailer": "Sélectionner la remorque",

  "Trailer not selected": "Remorque non sélectionnée",

  "Select the trailer with the marked defect to finish inspection.": "Sélectionnez la remorque présentant le défaut signalé pour terminer l'inspection.",

  "Trailer condition not selected": "État de la remorque non sélectionné",

  "Select one of the trailer conditions to finish inspection.": "Sélectionnez l'un des états de la remorque pour terminer l'inspection.",

  "Do you wish to mark all the unmarked parts as OK?": "Souhaitez-vous marquer toutes les parties non marquées comme OK ?",

  "The following vehicle was repaired": "Le véhicule suivant a été réparé",

  "Please sign all policies and procedures.": "Veuillez signer toutes les politiques et procédures.",

  "Add New Vehicle": "Ajouter un nouveau véhicule",

  "UNIT ID": "ID de l'unité",

  "MAKE": "Marque",

  "PLATE NUMBER": "Numéro de plaque",

  "CURRENT ODOMETER": "ODOMÈTRE ACTUEL",

  "GVW": "PTC",

  "NEXT MAINTENANCE DAY": "Prochain jour d'entretien",

  "NOTES": "Remarques",

  "ELD SERIAL NUMBER": "ELD Numéro de série",

  "HARDWARE TYPE": "Type de matériel",

  "ELD TYPE": "TYPE D'ELD",

  "YEAR": "Année",

  "MODEL": "Modèle",

  "Select Vehicle Type": "Sélectionnez le type de véhicule",

  "Select Hardware Type": "Sélectionner le type de matériel",

  "Select ELD TYPE": "Sélectionnez le type d'ELD",

  "Fixed": "Fixe",

  "Cannot mark as complete until all defects are fixed.": "Impossible de marquer comme terminé tant que tous les défauts ne sont pas corrigés.",

  "Please approve or reject all defect fixes before submitting review.": "Veuillez approuver ou rejeter toutes les corrections de défauts avant de soumettre votre avis.",

  "Due to no internet connectivity, accident report will be sent later": "En raison d'une connexion Internet indisponible, le rapport d'accident sera envoyé ultérieurement.",

  "Accident report was successfully sent": "Le rapport d'accident a été envoyé avec succès",

  "ADD PARTY INVOLVED": "ajouter une partie impliquée",

  "TYPE": "Type",

  "FULL NAME": "Nom complet",

  "PHONE": "Téléphone",

  "STATE": "État",

  "CITY": "ville",

  "ADDRESS": "Adresse",

  "INSURANCE INFORMATION": "informations d'assurance",

  "Audio statement": "déclaration audio",

  "BROADVIEW": "Broadview",

  "BROADVIEW 2": "broadview 2",

  "DRIVER FRONT": "conducteur avant",

  "PASSENGER FRONT": "passager avant",

  "DRIVER REAR": "conducteur arrière",

  "PASSENGER REAR": "passager arrière",

  "OTHER VEHICLE AND PROPERTY DAMAGE": "autres dommages matériels et aux véhicules",

  "Other Driver": "autre conducteur",

  "Passenger of Other Vehicle": "passager de l'autre véhicule",

  "Witness": "Témoin",

  "Firmware Update available!": "Mise à jour du micrologiciel disponible !",

  "Tap on the Firmware Update Button in ELD Info screen": "Appuyez sur le bouton « Mise à jour du micrologiciel » dans l'écran « Informations ELD ».",

  "You are not connected to the Internet. You can only view downloaded work orders.": "Vous n'êtes pas connecté à Internet. Vous ne pouvez consulter que les bons de travail téléchargés.",

  "Trailer Compliant With 396 Regulations?": "Remorque conforme à la réglementation 396 ?",

  "Enter Unit id or VIN number": "Entrez l'identifiant de l'unité ou le numéro d'identification du véhicule (VIN)",

  "Sorry no trailer found": "Désolé, aucune remorque trouvée",

  "There is an unidentified driver on the ELD.": "Il y a un conducteur non identifié dans l'ELD.",

  "Drop a file here or click to upload": "Déposez un fichier ici ou cliquez pour le télécharger",

  "%s ELD has identified a data diagnostic event. The %s ELD Diagnostic Event is %s.": "%s ELD a identifié un événement de diagnostic de données. L'événement de diagnostic %s ELD est %s.",

}